/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/helpers/format-money.js":
/*!****************************************!*\
  !*** ./src/js/helpers/format-money.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   formatMoney: () => (/* binding */ formatMoney)
/* harmony export */ });
var formatMoney = function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || '${{amount}}';
  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }
  var value = '';
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, ',', '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
  }
  if (formatString.indexOf('with_comma_separator') !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
};

/***/ }),

/***/ "./src/js/modules/ed-article-header-buttons.js":
/*!*****************************************************!*\
  !*** ./src/js/modules/ed-article-header-buttons.js ***!
  \*****************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var EdArticleHeaderButtns = /*#__PURE__*/function (_HTMLElement) {
  function EdArticleHeaderButtns() {
    _classCallCheck(this, EdArticleHeaderButtns);
    return _callSuper(this, EdArticleHeaderButtns, arguments);
  }
  _inherits(EdArticleHeaderButtns, _HTMLElement);
  return _createClass(EdArticleHeaderButtns, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      if (this.printer) {
        this._setupPrinter(this.printer);
      }
      if (this.share) {
        this._setupSharing(this.share);
      }
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.printer = this.querySelector('li[data-type="printer"]');
      this.share = this.querySelector('li[data-type="share"]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      // add listeners if neeeded
    }
  }, {
    key: "_removeHover",
    value: function _removeHover(elem) {
      elem.style.pointerEvents = 'none';
      setTimeout(function () {
        elem.style.pointerEvents = '';
      }, 500);
    }
  }, {
    key: "_setupPrinter",
    value: function _setupPrinter(elem) {
      var _this = this;
      elem.addEventListener('click', function () {
        _this._removeHover(elem);
        window.print();
      });
    }
  }, {
    key: "_setupSharing",
    value: function _setupSharing(elem) {
      var _this2 = this;
      var isAnimating = false;
      elem.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (isAnimating) return;
        isAnimating = true;
        var firstSpan = elem.querySelector('span:first-of-type');
        var lastSpan = elem.querySelector('span:last-of-type');
        firstSpan.style.display = 'none';
        lastSpan.style.display = 'block';
        lastSpan.style.opacity = '1';
        var currentUrl = window.location.href;
        navigator.clipboard.writeText(currentUrl).then(function () {
          console.log('URL copied to clipboard');
          _this2._animateSpans(firstSpan, lastSpan, function () {
            isAnimating = false;
            _this2._removeHover(elem);
          });
        })["catch"](function (err) {
          console.error('Failed to copy URL: ', err);
          _this2._animateSpans(firstSpan, lastSpan, function () {
            isAnimating = false;
            _this2._removeHover(elem);
          });
        });
      });
    }
  }, {
    key: "_animateSpans",
    value: function _animateSpans(firstSpan, lastSpan, callback) {
      var _this3 = this;
      setTimeout(function () {
        lastSpan.style.transition = 'opacity 0.5s';
        lastSpan.style.opacity = '0';
        setTimeout(function () {
          _this3._removeInlineStyles(firstSpan);
          _this3._removeInlineStyles(lastSpan);
          callback();
        }, 500);
      }, 1000);
    }
  }, {
    key: "_removeInlineStyles",
    value: function _removeInlineStyles(element) {
      element.removeAttribute('style');
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-article-header-buttons')) {
  customElements.define('ed-article-header-buttons', EdArticleHeaderButtns);
}

/***/ }),

/***/ "./src/js/modules/ed-article-popup-video.js":
/*!**************************************************!*\
  !*** ./src/js/modules/ed-article-popup-video.js ***!
  \**************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var ArticlePopupVideo = /*#__PURE__*/function (_HTMLElement) {
  function ArticlePopupVideo() {
    _classCallCheck(this, ArticlePopupVideo);
    return _callSuper(this, ArticlePopupVideo, arguments);
  }
  _inherits(ArticlePopupVideo, _HTMLElement);
  return _createClass(ArticlePopupVideo, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.imageWrapper = this.querySelector('.deferred-media__poster-button').closest('.ed-article-header__image-wrapper');
      this.modal = document.querySelector('.article-video-modal');
      this.iframe = this.modal.querySelector('iframe');
      this.closeButton = this.modal.querySelector('.close');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      if (this.imageWrapper) {
        this.imageWrapper.addEventListener('click', function () {
          return _this.openModal();
        });
      }
      if (this.closeButton) {
        this.closeButton.addEventListener('click', function () {
          return _this.closeModal();
        });
      }
      document.addEventListener('click', function (event) {
        if (event.target === _this.modal) {
          _this.closeModal();
        }
      });
    }
  }, {
    key: "openModal",
    value: function openModal() {
      this.modal.style.display = 'block';
      document.body.classList.add('overflow-hidden');
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.iframe.src = this.iframe.src.replace("&autoplay=1", ""); // stop video
      this.modal.style.display = 'none';
      document.body.classList.remove('overflow-hidden');
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-article-popup-video', ArticlePopupVideo);

/***/ }),

/***/ "./src/js/modules/ed-article-upsells.js":
/*!**********************************************!*\
  !*** ./src/js/modules/ed-article-upsells.js ***!
  \**********************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var EdArticleUpsells = /*#__PURE__*/function (_HTMLElement) {
  function EdArticleUpsells() {
    _classCallCheck(this, EdArticleUpsells);
    return _callSuper(this, EdArticleUpsells, arguments);
  }
  _inherits(EdArticleUpsells, _HTMLElement);
  return _createClass(EdArticleUpsells, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      this.cart = document.querySelector('cart-drawer');
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.upsellItemsInner = this.querySelector('[data-drag-scroll]');
      this.upsellItems = this.querySelectorAll('li');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      if (this.upsellItemsInner) {
        this.initDragScroll();
      }
      if (this.upsellItems) {
        this.upsellItems.forEach(function (item) {
          var atcButton = item.querySelector('.ed-article-upsells__add');
          var productId = item.dataset.id;
          var taxRate = item.dataset.taxRate;
          if (atcButton && productId && taxRate) {
            atcButton.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              if (atcButton.getAttribute('disabled') != null) {
                return;
              }
              atcButton.setAttribute('disabled', '');
              _this.addVariantToCart(productId, taxRate);
              setTimeout(function () {
                atcButton.removeAttribute('disabled');
              }, 1000);
            });
          } else {
            console.error("Missing inputs.");
          }
        });
      }
    }
  }, {
    key: "addVariantToCart",
    value: function () {
      var _addVariantToCart = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(id, taxRate) {
        var config, formData, response, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              config = fetchConfig('javascript');
              config.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete config.headers['Content-Type'];
              formData = new FormData();
              formData.append('sections', this.cart.getSectionsToRender().map(function (section) {
                return section.id;
              }));
              formData.append('sections_url', window.location.pathname);
              formData.append('properties[_ed-cart-upsell]', 'true');

              // Append item details into the FormData
              formData.append('items[0][id]', id);
              formData.append('items[0][quantity]', '1');
              formData.append('items[0][properties][_tax_rate]', taxRate);
              this.cart.setActiveElement(document.activeElement);
              config.body = formData;
              _context.prev = 12;
              _context.next = 15;
              return fetch(window.Shopify.routes.root + 'cart/add.js', config);
            case 15:
              response = _context.sent;
              _context.next = 18;
              return response.json();
            case 18:
              result = _context.sent;
              this.cart.renderContents(result);
              if (this.cart.classList.contains('is-empty')) {
                this.cart.classList.remove('is-empty');
              }
              _context.next = 27;
              break;
            case 23:
              _context.prev = 23;
              _context.t0 = _context["catch"](12);
              console.error('Error:', _context.t0);
              throw _context.t0;
            case 27:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[12, 23]]);
      }));
      function addVariantToCart(_x, _x2) {
        return _addVariantToCart.apply(this, arguments);
      }
      return addVariantToCart;
    }()
  }, {
    key: "initDragScroll",
    value: function initDragScroll() {
      var _this2 = this;
      var isDragging = false;
      var startX;
      var scrollLeft;
      this.upsellItemsInner.addEventListener('mousedown', function (e) {
        isDragging = true;
        _this2.upsellItemsInner.classList.add('active'); // Optional: Add a class for visual feedback
        startX = e.pageX - _this2.upsellItemsInner.offsetLeft;
        scrollLeft = _this2.upsellItemsInner.scrollLeft;
      });
      this.upsellItemsInner.addEventListener('mouseleave', function () {
        isDragging = false;
        _this2.upsellItemsInner.classList.remove('active');
      });
      this.upsellItemsInner.addEventListener('mouseup', function () {
        isDragging = false;
        _this2.upsellItemsInner.classList.remove('active');
      });
      this.upsellItemsInner.addEventListener('mousemove', function (e) {
        if (!isDragging) return; // Stop the function if not clicked
        e.preventDefault();
        var x = e.pageX - _this2.upsellItemsInner.offsetLeft;
        var walk = (x - startX) * 2; // Adjust the scroll speed by changing the multiplier
        _this2.upsellItemsInner.scrollLeft = scrollLeft - walk;
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-article-upsells', EdArticleUpsells);

/***/ }),

/***/ "./src/js/modules/ed-blog-slider.js":
/*!******************************************!*\
  !*** ./src/js/modules/ed-blog-slider.js ***!
  \******************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var BlogSlider = /*#__PURE__*/function (_HTMLElement) {
  function BlogSlider() {
    _classCallCheck(this, BlogSlider);
    return _callSuper(this, BlogSlider, arguments);
  }
  _inherits(BlogSlider, _HTMLElement);
  return _createClass(BlogSlider, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._initializeSwiper();
    }
  }, {
    key: "_initializeSwiper",
    value: function _initializeSwiper() {
      var _this = this;
      document.addEventListener('DOMContentLoaded', function () {
        new Swiper(_this.querySelector('.swiper-container'), {
          slidesPerView: 3,
          navigation: {
            nextEl: _this.querySelector('.swiper-button-next'),
            prevEl: _this.querySelector('.swiper-button-prev')
          },
          observer: true,
          observerParents: true,
          grabCursor: false,
          breakpoints: {
            0: {
              slidesPerView: 1,
              initialSlide: 1,
              loop: false,
              effect: "coverflow",
              centeredSlides: true,
              spaceBetween: -230,
              coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 800,
                modifier: 1,
                slideShadows: false
              }
            },
            768: {
              slidesPerView: 3,
              centeredSlides: false,
              effect: 'slide',
              spaceBetween: 20,
              loop: false
            }
          }
        });
        var videos = document.querySelectorAll('.video-wrapper');
        videos.forEach(function (video) {
          var clickToPlayVideo = video.querySelector('video.click-to-play');
          var playButton = video.querySelector('.deferred-media__poster-button');
          playButton.addEventListener('click', function () {
            clickToPlayVideo.play();
            clickToPlayVideo.volume = 0.5;
            playButton.style.display = 'none';
          });
          clickToPlayVideo.addEventListener('click', function () {
            clickToPlayVideo.pause();
            playButton.style.display = 'flex';
          });
        });
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-blog-slider')) {
  customElements.define('ed-blog-slider', BlogSlider);
}

/***/ }),

/***/ "./src/js/modules/ed-cart-outbrain-cid.js":
/*!************************************************!*\
  !*** ./src/js/modules/ed-cart-outbrain-cid.js ***!
  \************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var EdCartOutbrainCid = /*#__PURE__*/function (_HTMLElement) {
  function EdCartOutbrainCid() {
    _classCallCheck(this, EdCartOutbrainCid);
    return _callSuper(this, EdCartOutbrainCid, arguments);
  }
  _inherits(EdCartOutbrainCid, _HTMLElement);
  return _createClass(EdCartOutbrainCid, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;
      this.checkCookieInterval = setInterval(function () {
        return _this.checkForCookie();
      }, 1000);
      this.timeoutId = setTimeout(function () {
        return _this.stopChecking();
      }, 3000);
    }
  }, {
    key: "checkForCookie",
    value: function checkForCookie() {
      var outbrainCid = this.getCookie('outbrain_cid');
      if (outbrainCid) {
        //this.createInputElement(outbrainCid);
        this.updateCartAttribute(outbrainCid);
        this.stopChecking();
      }
    }
  }, {
    key: "stopChecking",
    value: function stopChecking() {
      clearInterval(this.checkCookieInterval);
      clearTimeout(this.timeoutId);
    }
  }, {
    key: "createInputElement",
    value: function createInputElement(value) {
      var input = document.createElement('input');
      input.id = 'outbrain-cid';
      input.name = 'attributes[outbrain_cid]';
      input.type = 'text';
      input.style.display = 'none';
      input.setAttribute('value', value);
      input.value = value;
      this.appendChild(input);
    }
  }, {
    key: "updateCartAttribute",
    value: function updateCartAttribute(value) {
      var request = {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            outbrain_cid: value
          }
        })
      };
      fetch('/cart/update.js', request).then(function () {
        console.log('ocid updated');
      });
    }
  }, {
    key: "getCookie",
    value: function getCookie(name) {
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        if (cookie.startsWith(name + '=')) {
          return decodeURIComponent(cookie.substring(name.length + 1));
        }
      }
      return null;
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-cart-outbrain-cid', EdCartOutbrainCid);

/***/ }),

/***/ "./src/js/modules/ed-cart-progress.js":
/*!********************************************!*\
  !*** ./src/js/modules/ed-cart-progress.js ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _helpers_format_money__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/format-money */ "./src/js/helpers/format-money.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }

var EdCartProgress = /*#__PURE__*/function (_HTMLElement) {
  function EdCartProgress() {
    _classCallCheck(this, EdCartProgress);
    return _callSuper(this, EdCartProgress, arguments);
  }
  _inherits(EdCartProgress, _HTMLElement);
  return _createClass(EdCartProgress, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      this._restorePreviousState();
      if (this.cart) {
        this._cartTotal();
        this._enableLoading();
      } else {
        console.error('Cart or Drawer Items not found');
      }
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.progressBarElement = this.querySelector('.ed-cart-progress__bar-colored');
      this.progressTextElement = this.querySelector('.ed-cart-progress__text');
      this.configurationScript = this.querySelector('script[data-cart-progress-configuration]');
      this.drawerItems = document.querySelector('cart-drawer-items');
      this.cart = document.querySelector('cart-drawer');
      this.cartItems = this.cart.querySelectorAll('.cart-item');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      // Add event listeners if needed
    }
  }, {
    key: "_restorePreviousState",
    value: function _restorePreviousState() {
      var savedProgress = sessionStorage.getItem('edCartProgressBar');
      var savedText = sessionStorage.getItem('edCartProgressText');
      var savedTotal = sessionStorage.getItem('edCartPreviousTotal');
      var savedThreshold = sessionStorage.getItem('edCartPreviousThreshold');
      if (savedProgress && this.progressBarElement) {
        this.progressBarElement.style.transition = 'none';
        this.progressBarElement.style.width = savedProgress;
        this.progressBarElement.offsetHeight;
        this.progressBarElement.style.transition = '';
      }
      if (savedText && this.progressTextElement) {
        this.progressTextElement.innerHTML = savedText;
      }
      if (savedTotal && savedThreshold) {
        this._calcProgress(parseFloat(savedTotal), parseFloat(savedThreshold));
      }
    }
  }, {
    key: "handle",
    get: function get() {
      return this.dataset.handle || null;
    }
  }, {
    key: "configuration",
    get: function get() {
      if (this.configurationScript) {
        return JSON.parse(this.configurationScript.textContent);
      }
      return null;
    }
  }, {
    key: "_nextMilestone",
    value: function _nextMilestone(total) {
      var milestones = [];
      milestones.push({
        id: '1',
        title: this.configuration.shipping_title,
        threshold: this.configuration.shipping_threshold
      });
      var _iterator = _createForOfIteratorHelper(this.configuration.items),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          milestones.push({
            id: item.id,
            title: item.title,
            threshold: item.threshold
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      milestones.sort(function (a, b) {
        return a.threshold - b.threshold;
      });
      for (var _i = 0, _milestones = milestones; _i < _milestones.length; _i++) {
        var milestone = _milestones[_i];
        if (milestone.threshold > total) {
          return milestone;
        }
      }
      return null;
    }
  }, {
    key: "_transformText",
    value: function _transformText(price, title) {
      var config = this.configuration;
      if (config && config.text) {
        var text = config.text;
        price = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(price, '{{amount_with_comma_separator}}');
        text = text.replace('[PRICE]', "<span>".concat(price, " ").concat(config.currency, "</span>")).replace('[TITLE]', title);
        return text;
      } else {
        console.error('Missing text');
        return null;
      }
    }
  }, {
    key: "progressText",
    set: function set(text) {
      if (this.progressTextElement) {
        this.progressTextElement.innerHTML = text;
        sessionStorage.setItem('edCartProgressText', text);
      }
    }
  }, {
    key: "_calcProgress",
    value: function _calcProgress(total, threshold) {
      var _this = this;
      var skipAnimation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return new Promise(function (resolve) {
        var currentPercentage = total / threshold * 100;

        // Skip animation if all milestones are reached
        if (skipAnimation) {
          _this.progressBar = 100;
          sessionStorage.setItem('edCartPreviousTotal', total.toString());
          sessionStorage.setItem('edCartPreviousThreshold', threshold.toString());
          resolve();
          return;
        }
        var previousTotal = parseFloat(sessionStorage.getItem('edCartPreviousTotal') || '0');
        var previousThreshold = parseFloat(sessionStorage.getItem('edCartPreviousThreshold') || threshold);
        if (threshold !== previousThreshold) {
          if (total > previousTotal) {
            _this._transitionToNextMilestone(total, threshold, resolve);
          } else {
            _this._animateToPreviousMilestone(total, threshold, resolve);
          }
        } else {
          _this.progressBar = currentPercentage;
          resolve();
        }
        sessionStorage.setItem('edCartPreviousTotal', total.toString());
        sessionStorage.setItem('edCartPreviousThreshold', threshold.toString());
      });
    }
  }, {
    key: "_transitionToNextMilestone",
    value: function _transitionToNextMilestone(total, threshold, resolve) {
      var _this2 = this;
      this._animateToFull(function () {
        if (_this2.progressBarElement) {
          _this2.progressBarElement.style.transition = 'none';
          _this2.progressBarElement.style.width = '0%';
          _this2.progressBarElement.offsetHeight; // Force reflow
          _this2.progressBarElement.style.transition = '';
        }
        var newPercentage = total / threshold * 100;
        requestAnimationFrame(function () {
          _this2.progressBar = newPercentage;
          resolve();
        });
      });
    }
  }, {
    key: "_animateToPreviousMilestone",
    value: function _animateToPreviousMilestone(total, threshold, resolve) {
      var _this3 = this;
      this._animateToZero(function () {
        if (_this3.progressBarElement) {
          _this3.progressBarElement.style.transition = 'none';
          _this3.progressBarElement.style.width = '100%';
          _this3.progressBarElement.offsetHeight;
          _this3.progressBarElement.style.transition = '';
        }
        var newPercentage = total / threshold * 100;
        requestAnimationFrame(function () {
          _this3.progressBar = newPercentage;
          resolve();
        });
      });
    }
  }, {
    key: "_animateToFull",
    value: function _animateToFull(callback) {
      if (this.progressBarElement) {
        this.progressBarElement.style.transition = 'width 0.5s ease-in-out';
        this.progressBarElement.style.width = '100%';
        sessionStorage.setItem('edCartProgressBar', '100%');
        this.progressBarElement.addEventListener('transitionend', function () {
          if (callback) callback();
        }, {
          once: true
        });
      }
    }
  }, {
    key: "_animateToZero",
    value: function _animateToZero(callback) {
      if (this.progressBarElement) {
        this.progressBarElement.style.transition = 'width 0.5s ease-in-out';
        this.progressBarElement.style.width = '0%';
        sessionStorage.setItem('edCartProgressBar', '0%');
        this.progressBarElement.addEventListener('transitionend', function () {
          if (callback) callback();
        }, {
          once: true
        });
      }
    }
  }, {
    key: "progressBar",
    set: function set(percentage) {
      if (this.progressBarElement) {
        var width = percentage + '%';
        this.progressBarElement.style.width = width;
        sessionStorage.setItem('edCartProgressBar', width);
      }
    }
  }, {
    key: "_addVariantsToCart",
    value: function () {
      var _addVariantsToCart2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(variants) {
        var _this4 = this;
        var config, formData, res, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              config = fetchConfig('javascript');
              config.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete config.headers['Content-Type'];
              formData = new FormData();
              formData.append('sections', this.cart.getSectionsToRender().map(function (section) {
                return section.id;
              }));
              formData.append('sections_url', window.location.pathname);
              variants.forEach(function (variant, index) {
                formData.append("items[".concat(index, "][id]"), variant.id);
                formData.append("items[".concat(index, "][quantity]"), '1');
                formData.append("items[".concat(index, "][properties][_ed-free-gift]"), 'true');
                formData.append("items[".concat(index, "][properties][_upsell]"), 'true');
                formData.append("items[".concat(index, "][properties][_hash]"), _this4.configuration.hash);
                formData.append("items[".concat(index, "][properties][_token]"), _this4.configuration.upsell_token);
              });
              this.cart.setActiveElement(document.activeElement);
              config.body = formData;
              _context.prev = 9;
              _context.next = 12;
              return fetch(window.Shopify.routes.root + 'cart/add.js', config);
            case 12:
              res = _context.sent;
              _context.next = 15;
              return res.json();
            case 15:
              result = _context.sent;
              this.cart.renderContents(result);
              variants.forEach(function (variant) {
                var text = variant.title + ' ' + _this4.configuration.gift_added;
                _this4._dispatchToast(3000, text, 'info');
              });
              _context.next = 23;
              break;
            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](9);
              console.error('Error:', _context.t0);
            case 23:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[9, 20]]);
      }));
      function _addVariantsToCart(_x) {
        return _addVariantsToCart2.apply(this, arguments);
      }
      return _addVariantsToCart;
    }()
  }, {
    key: "_removeVariantsFromCart",
    value: function () {
      var _removeVariantsFromCart2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(variants) {
        var _this5 = this;
        var config, formData, res, result, addedMilestones;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              config = fetchConfig('javascript');
              config.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete config.headers['Content-Type'];
              formData = new FormData();
              formData.append('sections', this.cart.getSectionsToRender().map(function (section) {
                return section.id;
              }));
              formData.append('sections_url', window.location.pathname);
              variants.forEach(function (variant) {
                formData.append("updates[".concat(variant.key, "]"), 0);
              });
              this.cart.setActiveElement(document.activeElement);
              config.body = formData;
              _context2.prev = 9;
              _context2.next = 12;
              return fetch(window.Shopify.routes.root + 'cart/update.js', config);
            case 12:
              res = _context2.sent;
              _context2.next = 15;
              return res.json();
            case 15:
              result = _context2.sent;
              this.cart.renderContents(result);
              addedMilestones = JSON.parse(sessionStorage.getItem('edAddedMilestones')) || {};
              variants.forEach(function (variant) {
                var savedTitle = addedMilestones[variant.id] ? addedMilestones[variant.id].title : 'Unknown Product';
                var text = savedTitle + ' ' + _this5.configuration.product_removed;
                _this5._dispatchToast(3000, text, 'error');
              });
              _context2.next = 24;
              break;
            case 21:
              _context2.prev = 21;
              _context2.t0 = _context2["catch"](9);
              console.error('Error:', _context2.t0);
            case 24:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[9, 21]]);
      }));
      function _removeVariantsFromCart(_x2) {
        return _removeVariantsFromCart2.apply(this, arguments);
      }
      return _removeVariantsFromCart;
    }()
  }, {
    key: "_checkCart",
    value: function () {
      var _checkCart2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(items, total) {
        var milestones, addedMilestones, shippingThreshold, previousHadFreeShipping, currentHasFreeShipping, itemsToAdd, itemsToRemove;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              milestones = this.configuration.items;
              addedMilestones = JSON.parse(sessionStorage.getItem('edAddedMilestones')) || {};
              shippingThreshold = this.configuration.shipping_threshold;
              previousHadFreeShipping = JSON.parse(sessionStorage.getItem('edCartHadFreeShipping') || 'false');
              currentHasFreeShipping = total >= shippingThreshold;
              if (currentHasFreeShipping && !previousHadFreeShipping) {
                this._dispatchToast(3000, this.configuration.shipping_added, 'info');
              } else if (!currentHasFreeShipping && previousHadFreeShipping) {
                this._dispatchToast(3000, this.configuration.shipping_removed, 'error');
              }
              sessionStorage.setItem('edCartHadFreeShipping', JSON.stringify(currentHasFreeShipping));
              itemsToAdd = [];
              itemsToRemove = [];
              items.forEach(function (item) {
                var milestone = milestones.find(function (m) {
                  return m.id === item.id;
                });
                if (milestone && total < milestone.threshold && item.properties['_ed-free-gift'] === "true") {
                  itemsToRemove.push({
                    id: item.id,
                    key: item.key,
                    title: item.title
                  });
                  var existingTitle = addedMilestones[item.id] && addedMilestones[item.id].title;
                  addedMilestones[item.id] = {
                    added: false,
                    title: existingTitle || item.title
                  };
                }
              });
              milestones.forEach(function (_ref) {
                var id = _ref.id,
                  threshold = _ref.threshold,
                  title = _ref.title;
                var isItemInCart = items.some(function (item) {
                  return item.id === id && item.properties['_ed-free-gift'] === "true";
                });
                var wasAddedBefore = addedMilestones[id] && addedMilestones[id].added;
                if (!isItemInCart && total >= threshold && !wasAddedBefore) {
                  itemsToAdd.push({
                    id: id,
                    title: title
                  });
                  var existingTitle = addedMilestones[id] && addedMilestones[id].title;
                  addedMilestones[id] = {
                    added: true,
                    title: existingTitle || title
                  };
                }
              });
              Object.keys(addedMilestones).forEach(function (id) {
                var milestoneExists = milestones.some(function (m) {
                  return m.id.toString() === id;
                });
                if (!milestoneExists) {
                  delete addedMilestones[id];
                }
              });
              if (!(itemsToAdd.length > 0)) {
                _context3.next = 15;
                break;
              }
              _context3.next = 15;
              return this._addVariantsToCart(itemsToAdd);
            case 15:
              if (!(itemsToRemove.length > 0)) {
                _context3.next = 18;
                break;
              }
              _context3.next = 18;
              return this._removeVariantsFromCart(itemsToRemove);
            case 18:
              sessionStorage.setItem('edAddedMilestones', JSON.stringify(addedMilestones));
            case 19:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function _checkCart(_x3, _x4) {
        return _checkCart2.apply(this, arguments);
      }
      return _checkCart;
    }()
  }, {
    key: "_enableLoading",
    value: function _enableLoading() {
      var items = [];
      if (this.drawerItems) {
        items = this.drawerItems.querySelectorAll('[data-gift="true"][data-active="false"]');
      } else {
        console.warn('this.drawerItems is null or undefined');
      }
      var addedMilestones = JSON.parse(sessionStorage.getItem('edAddedMilestones')) || {};
      items.forEach(function (item) {
        var cartItemId = item.dataset.id;
        var addBtn = item.querySelector('cart-add-button');
        var spinner = item.querySelector('.loading__spinner');
        if (!addedMilestones[cartItemId] || !addedMilestones[cartItemId].added) {
          if (addBtn) {
            addBtn.classList.add('hidden');
            spinner.classList.remove('hidden');
          }
        }
      });
    }
  }, {
    key: "_dispatchToast",
    value: function _dispatchToast(duration, text, type) {
      var lastToasts = JSON.parse(sessionStorage.getItem('edLastToasts')) || [];
      var currentTime = Date.now();
      var toastTimeLimit = 3000;
      lastToasts = lastToasts.filter(function (toast) {
        return currentTime - toast.time < toastTimeLimit;
      });
      var isDuplicate = lastToasts.some(function (toast) {
        return toast.text === text;
      });
      if (isDuplicate) {
        return;
      }
      document.dispatchEvent(new CustomEvent('ed:toast:notification:trigger', {
        detail: {
          duration: duration,
          text: text,
          type: type
        }
      }));
      lastToasts.push({
        text: text,
        time: currentTime
      });
      if (lastToasts.length > 5) {
        lastToasts.shift();
      }
      sessionStorage.setItem('edLastToasts', JSON.stringify(lastToasts));
    }
  }, {
    key: "_handleCartOperations",
    value: function () {
      var _handleCartOperations2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(items, total) {
        var milestone, allMilestonesReached;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              milestone = this._nextMilestone(total);
              allMilestonesReached = milestone === null;
              _context4.next = 4;
              return this._calcProgress(total, milestone ? milestone.threshold : total, allMilestonesReached);
            case 4:
              this._checkCart(items, total);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function _handleCartOperations(_x5, _x6) {
        return _handleCartOperations2.apply(this, arguments);
      }
      return _handleCartOperations;
    }()
  }, {
    key: "_cartTotal",
    value: function () {
      var _cartTotal2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var response, data, cartValue, milestone, text;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return fetch('/cart.js', {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              });
            case 3:
              response = _context5.sent;
              if (response.ok) {
                _context5.next = 6;
                break;
              }
              throw new Error('Failed to fetch cart data');
            case 6:
              _context5.next = 8;
              return response.json();
            case 8:
              data = _context5.sent;
              cartValue = data.items.reduce(function (total, item) {
                if (item.requires_shipping !== false) {
                  return total + item.final_line_price;
                }
                return total;
              }, 0);
              milestone = this._nextMilestone(cartValue);
              if (milestone) {
                text = this._transformText(milestone.threshold - cartValue, milestone.title);
              } else {
                text = this.configuration.final_text;
              }
              _context5.next = 14;
              return this._handleCartOperations(data.items, cartValue);
            case 14:
              this.progressText = text;
              if (cartValue === 0 && data.item_count === 0) {
                this.cart.classList.add('is-empty');
              }
              return _context5.abrupt("return", cartValue);
            case 19:
              _context5.prev = 19;
              _context5.t0 = _context5["catch"](0);
              console.error('Error fetching cart value:', _context5.t0);
              return _context5.abrupt("return", null);
            case 23:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 19]]);
      }));
      function _cartTotal() {
        return _cartTotal2.apply(this, arguments);
      }
      return _cartTotal;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("ed-cart-progress", EdCartProgress);

/***/ }),

/***/ "./src/js/modules/ed-cart-upsells.js":
/*!*******************************************!*\
  !*** ./src/js/modules/ed-cart-upsells.js ***!
  \*******************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var EdCartUpsells = /*#__PURE__*/function (_HTMLElement) {
  function EdCartUpsells() {
    _classCallCheck(this, EdCartUpsells);
    return _callSuper(this, EdCartUpsells, arguments);
  }
  _inherits(EdCartUpsells, _HTMLElement);
  return _createClass(EdCartUpsells, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      this.cart = document.querySelector('cart-drawer');
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.upsellItemsInner = this.querySelector('[data-drag-scroll]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      if (this.upsellItemsInner) {
        this.initDragScroll();
      }
    }
  }, {
    key: "addVariantToCart",
    value: function () {
      var _addVariantToCart = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(id) {
        var config, formData, response, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              config = fetchConfig('javascript');
              config.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete config.headers['Content-Type'];
              formData = new FormData();
              formData.append('sections', this.cart.getSectionsToRender().map(function (section) {
                return section.id;
              }));
              formData.append('sections_url', window.location.pathname);
              formData.append('properties[_ed-cart-upsell]', 'true');

              // Append item details into the FormData
              formData.append('items[0][id]', id);
              formData.append('items[0][quantity]', '1');
              //formData.append('items[0][properties][_ed-cart-upsell]', 'true');
              this.cart.setActiveElement(document.activeElement);
              config.body = formData;
              _context.prev = 11;
              _context.next = 14;
              return fetch(window.Shopify.routes.root + 'cart/add.js', config);
            case 14:
              response = _context.sent;
              _context.next = 17;
              return response.json();
            case 17:
              result = _context.sent;
              this.cart.renderContents(result);
              _context.next = 25;
              break;
            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](11);
              console.error('Error:', _context.t0);
              throw _context.t0;
            case 25:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[11, 21]]);
      }));
      function addVariantToCart(_x) {
        return _addVariantToCart.apply(this, arguments);
      }
      return addVariantToCart;
    }()
    /** ORIGINAL METHOD **/
    /*
     addVariantToCart(id) {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
         const formData = new FormData();
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        formData.append('properties[_ed-cart-upsell]', 'true');
         // Append item details into the FormData
        formData.append('items[0][id]', id);
        formData.append('items[0][quantity]', '1');
        formData.append('items[0][properties][_ed-cart-upsell]', 'true');
        this.cart.setActiveElement(document.activeElement);
         config.body = formData;
        fetch(window.Shopify.routes.root + 'cart/add.js', config)
            .then(res => res.json())
            .then(res => {
                this.cart.renderContents(res);
            })
            .catch(error => {
                console.error('Error:', error);
            });
    }
     */
  }, {
    key: "initDragScroll",
    value: function initDragScroll() {
      var _this = this;
      var isDragging = false;
      var startX;
      var scrollLeft;
      this.upsellItemsInner.addEventListener('mousedown', function (e) {
        isDragging = true;
        _this.upsellItemsInner.classList.add('active'); // Optional: Add a class for visual feedback
        startX = e.pageX - _this.upsellItemsInner.offsetLeft;
        scrollLeft = _this.upsellItemsInner.scrollLeft;
      });
      this.upsellItemsInner.addEventListener('mouseleave', function () {
        isDragging = false;
        _this.upsellItemsInner.classList.remove('active');
      });
      this.upsellItemsInner.addEventListener('mouseup', function () {
        isDragging = false;
        _this.upsellItemsInner.classList.remove('active');
      });
      this.upsellItemsInner.addEventListener('mousemove', function (e) {
        if (!isDragging) return; // Stop the function if not clicked
        e.preventDefault();
        var x = e.pageX - _this.upsellItemsInner.offsetLeft;
        var walk = (x - startX) * 2; // Adjust the scroll speed by changing the multiplier
        _this.upsellItemsInner.scrollLeft = scrollLeft - walk;
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-cart-upsells', EdCartUpsells);
var EdCartUpsellItem = /*#__PURE__*/function (_HTMLElement2) {
  function EdCartUpsellItem() {
    _classCallCheck(this, EdCartUpsellItem);
    return _callSuper(this, EdCartUpsellItem, arguments);
  }
  _inherits(EdCartUpsellItem, _HTMLElement2);
  return _createClass(EdCartUpsellItem, [{
    key: "variantId",
    get: function get() {
      return this.getAttribute('variant-id');
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      this.cartUpsells = document.querySelector('ed-cart-upsells');
      this.cart = document.querySelector('cart-drawer');
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.btnAddToCart = this.querySelector('[data-btn-atc]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.btnAddToCart.addEventListener('click', this.onBtnAddToCart.bind(this));
    }
  }, {
    key: "onBtnAddToCart",
    value: function onBtnAddToCart() {
      var _this2 = this;
      if (this.btnAddToCart.getAttribute('disabled')) {
        return;
      }
      this.btnAddToCart.setAttribute('disabled', 'true');
      this.cartUpsells.addVariantToCart(this.variantId).then(function () {
        _this2.btnAddToCart.removeAttribute('disabled');
        if (_this2.cart.classList.contains('is-empty')) {
          _this2.cart.classList.remove('is-empty');
        }
      })["catch"](function () {
        // Handle error, e.g., re-enable button if an error occurs
        setTimeout(function () {
          _this2.btnAddToCart.removeAttribute('disabled');
        }, 1000);
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-cart-upsell-item', EdCartUpsellItem);

/***/ }),

/***/ "./src/js/modules/ed-countdown-announcement.js":
/*!*****************************************************!*\
  !*** ./src/js/modules/ed-countdown-announcement.js ***!
  \*****************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var EdCountdownAnnouncement = /*#__PURE__*/function (_HTMLElement) {
  function EdCountdownAnnouncement() {
    _classCallCheck(this, EdCountdownAnnouncement);
    return _callSuper(this, EdCountdownAnnouncement, arguments);
  }
  _inherits(EdCountdownAnnouncement, _HTMLElement);
  return _createClass(EdCountdownAnnouncement, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      this.loadCustomTimer();
      this.loadRemainingTime();
      if (this.customTimer && !this.endTime) {
        this.endTime = this._calculateEndTimeFromCustomTimer(this.customTimer);
      }

      // Function to remember the visibility, once the announcement has been seen
      if (this.getAttribute('remember-visibility') === 'true') {
        if (this.classList.contains('visible')) {
          this.setVisibilityEndTime();
        } else {
          this.checkAndSetVisibility();
        }
      }
      if (this.getAttribute('redeem-click')) {
        this.checkDiscountCodeRedeemed();
      }
      this.startCountdown();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.discountCodeContainer = this.querySelector('.code-container');
      this.discountCodeLabel = this.discountCodeContainer.querySelector('.discount-code-label');
      this.copiedTextElement = this.discountCodeContainer.querySelector('.copied-text');
      this.copyIcon = this.discountCodeContainer.querySelector('.icon-copy');
      var customTimerAttr = this.getAttribute('custom-timer');
      this.customTimer = customTimerAttr ? this._parseTimeString(customTimerAttr) : null;
      if (!this.customTimer) {
        var endTimeAttr = this.getAttribute('end-time');
        this.endTime = this._parseDateString(endTimeAttr);
      }

      // Added selectors for days
      this.daysWrap = this.querySelector('.days-wrap .value');
      this.daysWrapContainer = this.querySelector('.days-wrap');
      this.hoursWrap = this.querySelector('.hours-wrap .value');
      this.minutesWrap = this.querySelector('.minutes-wrap .value');
      this.secondsWrap = this.querySelector('.seconds-wrap .value');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      if (!this.getAttribute('redeem-click')) {
        // copy code function
        this.discountCodeContainer.addEventListener('click', this.onDiscountCodeClick.bind(this));
      } else {
        this.discountCodeContainer.addEventListener('click', this.onRedeemDiscountCode.bind(this));
      }
    }
  }, {
    key: "_parseDateString",
    value: function _parseDateString(dateString) {
      // Assuming the format is "DD/MM/YYYY HH:MM:SS"
      var parts = dateString.split(/\/|\s|:/);
      return new Date(parts[2], parts[1] - 1, parts[0], parts[3], parts[4], parts[5]);
    }
  }, {
    key: "_parseTimeString",
    value: function _parseTimeString(timeString) {
      // Assuming the format is "HH:MM:SS"
      var parts = timeString.split(':');
      return {
        hours: parseInt(parts[0], 10),
        minutes: parseInt(parts[1], 10),
        seconds: parseInt(parts[2], 10)
      };
    }
  }, {
    key: "_calculateEndTimeFromCustomTimer",
    value: function _calculateEndTimeFromCustomTimer(_ref) {
      var hours = _ref.hours,
        minutes = _ref.minutes,
        seconds = _ref.seconds;
      var now = new Date();
      return new Date(now.getTime() + hours * 60 * 60 * 1000 + minutes * 60 * 1000 + seconds * 1000);
    }
  }, {
    key: "onDiscountCodeClick",
    value: function () {
      var _onDiscountCodeClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
        var _this = this;
        var discountCode;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              e.stopPropagation();
              discountCode = this.discountCodeContainer.getAttribute('data-copy');
              _context.prev = 3;
              _context.next = 6;
              return navigator.clipboard.writeText(discountCode);
            case 6:
              this.discountCodeContainer.classList.add('copied');
              setTimeout(function () {
                _this.discountCodeContainer.classList.remove('copied');
              }, 2000);
              _context.next = 13;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);
              console.error('Failed to copy text: ', _context.t0);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3, 10]]);
      }));
      function onDiscountCodeClick(_x) {
        return _onDiscountCodeClick.apply(this, arguments);
      }
      return onDiscountCodeClick;
    }()
  }, {
    key: "onRedeemDiscountCode",
    value: function onRedeemDiscountCode() {
      var discountCode = this.getAttribute('redeem-click');
      var expirationTime = this.endTime.getTime();
      if (typeof Storage !== 'undefined') {
        sessionStorage.setItem('edCountdownDiscountRedeemed', discountCode);
        sessionStorage.setItem('edCountdownDiscountExpiration', expirationTime);
      }

      // Redirect
      var currentUrl = window.location.href;
      var currentPath = new URL(currentUrl).pathname;
      window.location.href = "/discount/".concat(discountCode, "/?redirect=").concat(currentPath);
    }
  }, {
    key: "checkDiscountCodeRedeemed",
    value: function checkDiscountCodeRedeemed() {
      var redeemText = this.getAttribute('redeem-text');
      var edCountdownDiscountRedeemed = sessionStorage.getItem('edCountdownDiscountRedeemed');
      var currentTime = Date.now();
      var expirationTimeStr = sessionStorage.getItem('edCountdownDiscountExpiration');
      var expirationTime = new Date(parseInt(expirationTimeStr, 10));
      if (edCountdownDiscountRedeemed && currentTime < expirationTime) {
        // replace discount code Text
        if (this.discountCodeLabel) {
          this.discountCodeLabel.textContent = redeemText;
        }
      }
    }
  }, {
    key: "startCountdown",
    value: function startCountdown() {
      var _this2 = this;
      this._updateCountdown();
      this.intervalId = setInterval(function () {
        _this2._updateCountdown();
      }, 1000);
      this.saveIntervalId = setInterval(function () {
        _this2.saveRemainingTime();
      }, 5000);
    }
  }, {
    key: "_updateCountdown",
    value: function _updateCountdown() {
      var now = new Date();
      var timeRemaining = this.endTime - now;
      if (timeRemaining <= 0) {
        clearInterval(this.intervalId);
        clearInterval(this.saveIntervalId);
        this._setCountdownValues(0, 0, 0, 0);
        sessionStorage.removeItem('edVisibilityEndTime');
        return;
      }
      var totalSeconds = Math.floor(timeRemaining / 1000);
      var days = Math.floor(totalSeconds / (24 * 3600));
      var hours = Math.floor(totalSeconds % (24 * 3600) / 3600);
      var minutes = Math.floor(totalSeconds % 3600 / 60);
      var seconds = totalSeconds % 60;
      if (days > 0) {
        this.daysWrapContainer.style.display = 'inline-block';
      } else {
        this.daysWrapContainer.style.display = 'none';
      }
      this._setCountdownValues(days, hours, minutes, seconds);
    }
  }, {
    key: "_setCountdownValues",
    value: function _setCountdownValues(days, hours, minutes, seconds) {
      if (days > 0) {
        this.daysWrap.textContent = String(days).padStart(2, '0');
      }
      this.hoursWrap.textContent = String(hours).padStart(2, '0');
      this.minutesWrap.textContent = String(minutes).padStart(2, '0');
      this.secondsWrap.textContent = String(seconds).padStart(2, '0');
    }
  }, {
    key: "saveRemainingTime",
    value: function saveRemainingTime() {
      if (this.endTime) {
        var now = new Date();
        var timeRemaining = this.endTime - now;
        if (timeRemaining > 0) {
          sessionStorage.setItem('edRemainingTime', timeRemaining);
        } else {
          sessionStorage.removeItem('edRemainingTime');
        }
      }
      if (this.customTimer) {
        sessionStorage.setItem('edCustomTimer', JSON.stringify(this.customTimer));
      }
    }
  }, {
    key: "loadRemainingTime",
    value: function loadRemainingTime() {
      var remainingTime = sessionStorage.getItem('edRemainingTime');
      if (remainingTime) {
        var now = new Date();
        this.endTime = new Date(now.getTime() + parseInt(remainingTime, 10));
      } else if (this.customTimer) {
        this.endTime = this._calculateEndTimeFromCustomTimer(this.customTimer);
      }
    }
  }, {
    key: "loadCustomTimer",
    value: function loadCustomTimer() {
      // method to observer timer changes. if so, remove/reset the timer
      var storedCustomTimer = sessionStorage.getItem('edCustomTimer');
      if (storedCustomTimer) {
        var parsedStoredCustomTimer = JSON.parse(storedCustomTimer);
        var customTimerAttr = this.getAttribute('custom-timer');
        var currentCustomTimer = customTimerAttr ? this._parseTimeString(customTimerAttr) : null;
        if (JSON.stringify(parsedStoredCustomTimer) !== JSON.stringify(currentCustomTimer)) {
          sessionStorage.removeItem('edRemainingTime');
          this.customTimer = currentCustomTimer;
        } else {
          this.customTimer = parsedStoredCustomTimer;
        }
      } else {
        var _customTimerAttr = this.getAttribute('custom-timer');
        this.customTimer = _customTimerAttr ? this._parseTimeString(_customTimerAttr) : null;
      }
    }

    /** REMEMBER VISIBILTIY FUNCTIONS **/
  }, {
    key: "checkAndSetVisibility",
    value: function checkAndSetVisibility() {
      var visibilityEndTime = sessionStorage.getItem('edVisibilityEndTime');
      if (visibilityEndTime) {
        var now = new Date().getTime();
        if (now < parseInt(visibilityEndTime, 10) && !this.classList.contains('visible')) {
          this.classList.add('visible');
        } else {
          sessionStorage.removeItem('edVisibilityEndTime');
        }
      }
    }
  }, {
    key: "setVisibilityEndTime",
    value: function setVisibilityEndTime() {
      var endTime;
      if (this.customTimer) {
        var _this$customTimer = this.customTimer,
          hours = _this$customTimer.hours,
          minutes = _this$customTimer.minutes,
          seconds = _this$customTimer.seconds;
        endTime = new Date().getTime() + (hours * 3600 + minutes * 60 + seconds) * 1000;
      } else if (this.endTime) {
        endTime = this.endTime.getTime();
      }
      if (endTime) {
        sessionStorage.setItem('edVisibilityEndTime', endTime.toString());
      }
    }

    /** END **/
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-countdown-announcement')) {
  customElements.define('ed-countdown-announcement', EdCountdownAnnouncement);
}

/***/ }),

/***/ "./src/js/modules/ed-featured-products.js":
/*!************************************************!*\
  !*** ./src/js/modules/ed-featured-products.js ***!
  \************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var EdFeaturedProducts = /*#__PURE__*/function (_HTMLElement) {
  function EdFeaturedProducts() {
    _classCallCheck(this, EdFeaturedProducts);
    return _callSuper(this, EdFeaturedProducts, arguments);
  }
  _inherits(EdFeaturedProducts, _HTMLElement);
  return _createClass(EdFeaturedProducts, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      this.switchTrack();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.tab_titles = this.querySelectorAll('.ed-featured-products__tabs li');
      this.product_tracks = this.querySelectorAll('.ed-featured-products__products');
      this.button_containers = this.querySelectorAll('.ed-featured-products__buttons');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      if (this.product_tracks) {
        this.product_tracks.forEach(function (track) {
          _this.initDragScroll(track);
          _this.handleArrows(track);
          track.addEventListener('scroll', function (e) {
            _this.handleArrows(event.target);
          });
        });
      }
      this.button_containers.forEach(function (container) {
        var leftButton = container.querySelector('.ed-featured-products__buttons-left');
        var rightButton = container.querySelector('.ed-featured-products__buttons-right');
        var dataId = container.getAttribute('data-id');
        var track = _this.querySelector(".ed-featured-products__products[data-id=\"".concat(dataId, "\"]"));
        var swipe = function swipe() {
          var item = track.querySelector('li');
          return item ? item.offsetWidth + 16 : 0;
        };
        leftButton.addEventListener('click', function () {
          return _this.swipeTrack(track, -swipe());
        });
        rightButton.addEventListener('click', function () {
          return _this.swipeTrack(track, swipe());
        });
      });
    }
  }, {
    key: "handleArrows",
    value: function handleArrows(track) {
      var trackId = track.dataset.id;
      var matchingButtonContainer = Array.from(this.button_containers).find(function (container) {
        return container.dataset.id === trackId;
      });
      if (track.childElementCount < 5) {
        matchingButtonContainer.setAttribute("hidden", true);
        return;
      }
      var arrowLeft = matchingButtonContainer.querySelector('.ed-featured-products__buttons-left');
      var arrowRight = matchingButtonContainer.querySelector('.ed-featured-products__buttons-right');
      var scrollMax = track.scrollWidth - track.clientWidth;

      // arrow right
      if (scrollMax - track.scrollLeft < 10) {
        arrowRight.setAttribute("disabled", "true");
      } else {
        arrowRight.removeAttribute("disabled");
      }

      // arrow left
      if (track.scrollLeft > 3) {
        arrowLeft.removeAttribute("disabled");
      } else {
        arrowLeft.setAttribute("disabled", "true");
      }
    }
  }, {
    key: "switchTrack",
    value: function switchTrack() {
      var _this2 = this;
      this.tab_titles.forEach(function (title) {
        title.addEventListener('click', function () {
          var dataId = title.getAttribute('data-id');
          _this2.tab_titles.forEach(function (t) {
            t.setAttribute('data-active', t.getAttribute('data-id') === dataId);
          });
          _this2.product_tracks.forEach(function (track) {
            track.setAttribute('data-active', track.getAttribute('data-id') === dataId);
            if (track.getAttribute('data-id') === dataId) {
              _this2.handleArrows(track);
            }
          });
          _this2.button_containers.forEach(function (container) {
            container.setAttribute('data-active', container.getAttribute('data-id') === dataId);
          });
        });
      });
    }
  }, {
    key: "addVariantToCart",
    value: function () {
      var _addVariantToCart = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(id) {
        var config, formData, response, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              config = fetchConfig('javascript');
              config.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete config.headers['Content-Type'];
              formData = new FormData();
              formData.append('sections', this.cart.getSectionsToRender().map(function (section) {
                return section.id;
              }));
              formData.append('sections_url', window.location.pathname);
              formData.append('items[0][id]', id);
              formData.append('items[0][quantity]', '1');
              this.cart.setActiveElement(document.activeElement);
              config.body = formData;
              _context.prev = 10;
              _context.next = 13;
              return fetch(window.Shopify.routes.root + 'cart/add.js', config);
            case 13:
              response = _context.sent;
              _context.next = 16;
              return response.json();
            case 16:
              result = _context.sent;
              this.cart.renderContents(result);
              _context.next = 24;
              break;
            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](10);
              console.error('Error:', _context.t0);
              throw _context.t0;
            case 24:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[10, 20]]);
      }));
      function addVariantToCart(_x) {
        return _addVariantToCart.apply(this, arguments);
      }
      return addVariantToCart;
    }()
  }, {
    key: "swipeTrack",
    value: function swipeTrack(track, distance) {
      track.scrollTo({
        left: track.scrollLeft + distance,
        behavior: 'smooth'
      });
    }
  }, {
    key: "initDragScroll",
    value: function initDragScroll(elem) {
      var isDragging = false;
      var startX;
      var scrollLeft;
      elem.addEventListener('mousedown', function (e) {
        e.preventDefault();
        isDragging = true;
        startX = e.pageX - elem.offsetLeft;
        scrollLeft = elem.scrollLeft;
        elem.classList.add('dragging');
      });
      elem.addEventListener('mouseleave', function () {
        isDragging = false;
        elem.classList.remove('dragging');
      });
      elem.addEventListener('mouseup', function () {
        isDragging = false;
        elem.classList.remove('dragging');
      });
      elem.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        e.preventDefault();
        var x = e.pageX - elem.offsetLeft;
        var walk = (x - startX) * 2;
        elem.scrollLeft = scrollLeft - walk;
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-featured-products', EdFeaturedProducts);

/***/ }),

/***/ "./src/js/modules/ed-ingredients-dropdown.js":
/*!***************************************************!*\
  !*** ./src/js/modules/ed-ingredients-dropdown.js ***!
  \***************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var IngredientsDropdown = /*#__PURE__*/function (_HTMLElement) {
  function IngredientsDropdown() {
    var _this;
    _classCallCheck(this, IngredientsDropdown);
    _this = _callSuper(this, IngredientsDropdown);
    _this._handleDocumentClick = _this._handleDocumentClick.bind(_this);
    return _this;
  }
  _inherits(IngredientsDropdown, _HTMLElement);
  return _createClass(IngredientsDropdown, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.dropdownToggle = this.querySelector('.ed-ingredients-dropdown');
      this.dropdownContent = this.querySelector('.dropdown-ingredient-selection');
      this.ingredientItems = this.querySelectorAll('.dropdown-ingredient-selection .dropdown-variant-wrapper');
      this.selectedIngredient = this.querySelector('.ed-selected-ingredient');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this2 = this;
      this.dropdownToggle.addEventListener('click', function () {
        return _this2.toggleDropdown();
      });
      this.ingredientItems.forEach(function (item) {
        item.addEventListener('click', function (e) {
          _this2.handleItemClick(e);
          _this2.closeDropdown();
        });
      });
    }
  }, {
    key: "toggleDropdown",
    value: function toggleDropdown() {
      var isDisplayed = this.dropdownContent.style.display === 'block';
      if (isDisplayed) {
        this.closeDropdown();
      } else {
        this.openDropdown();
      }
    }
  }, {
    key: "openDropdown",
    value: function openDropdown() {
      this.dropdownContent.style.display = 'block';
      this.dropdownToggle.setAttribute('open', '');
      document.addEventListener('click', this._handleDocumentClick, true);
    }
  }, {
    key: "closeDropdown",
    value: function closeDropdown() {
      this.dropdownContent.style.display = 'none';
      this.dropdownToggle.removeAttribute('open');
      document.removeEventListener('click', this._handleDocumentClick, true);
    }
  }, {
    key: "_handleDocumentClick",
    value: function _handleDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.closeDropdown();
      }
    }
  }, {
    key: "handleItemClick",
    value: function handleItemClick(e) {
      this.selectedIngredient.innerText = e.target.innerText;
      var tables = document.querySelectorAll('[data-ingredients-table]');
      var name = document.querySelector('[data-selected-variant]').dataset.selectedVariant;
      var selectedIngredient = document.querySelector('ed-ingredients-dropdown .ed-selected-ingredient').innerText;
      tables.forEach(function (table) {
        var isMatch = table.dataset.ingredientsProduct === name && table.dataset.ingredientsTable === selectedIngredient;
        table.classList.toggle('hidden', !isMatch);
      });

      // Hide the clicked item in the dropdown
      this.ingredientItems.forEach(function (item) {
        if (item.innerText === e.target.innerText) {
          item.style.display = 'none';
        } else {
          item.style.display = 'block';
        }
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-ingredients-dropdown', IngredientsDropdown);

/***/ }),

/***/ "./src/js/modules/ed-ingredients.js":
/*!******************************************!*\
  !*** ./src/js/modules/ed-ingredients.js ***!
  \******************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var EdIngredients = /*#__PURE__*/function (_HTMLElement) {
  function EdIngredients() {
    _classCallCheck(this, EdIngredients);
    return _callSuper(this, EdIngredients, arguments);
  }
  _inherits(EdIngredients, _HTMLElement);
  return _createClass(EdIngredients, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      this._calcAmount(this.input.value);
      this._handleResize = this._updateOrder.bind(this);
      window.addEventListener('resize', this._handleResize);
      window.matchMedia('print').addEventListener('change', this._handleResize);
      this._updateOrder();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      window.removeEventListener('resize', this._handleResize);
      window.matchMedia('print').removeEventListener('change', this._handleResize);
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.mainContent = document.querySelector('#MainContent');
      this.ingredients = this.querySelectorAll('.ingredient__value');
      this.minus = this.querySelector('.ed-ingredients__amount-minus');
      this.plus = this.querySelector('.ed-ingredients__amount-add');
      this.input = this.querySelector('.ed-ingredients__amount-value');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.minus.addEventListener('click', this._minus.bind(this));
      this.plus.addEventListener('click', this._plus.bind(this));
    }
  }, {
    key: "_plus",
    value: function _plus() {
      if (parseInt(this.input.value) < 20) {
        this.input.value = parseInt(this.input.value) + 1;
        this._calcAmount(this.input.value);
      }
    }
  }, {
    key: "_minus",
    value: function _minus() {
      if (parseInt(this.input.value) > 1) {
        this.input.value = parseInt(this.input.value) - 1;
        this._calcAmount(this.input.value);
      }
    }
  }, {
    key: "_calcAmount",
    value: function _calcAmount(amount) {
      var _this = this;
      if (this.ingredients) {
        this.ingredients.forEach(function (ingredient) {
          if (/\d/.test(ingredient.dataset.original)) {
            var originalText = ingredient.dataset.original;
            var value = parseFloat(originalText.match(/[\d.]+/)[0]);
            var unit = originalText.replace(/[\d.]+/, '').trim();
            var single = value / _this.dataset.people;
            var new_value = _this._roundToTwoAndFormat(single * amount);
            if (unit) {
              ingredient.textContent = new_value + ' ' + unit;
            } else {
              ingredient.textContent = new_value;
            }
          } else if (/^[a-zA-Z]+$/.test(ingredient.dataset.original)) {
            return;
          }
        });
      }
    }
  }, {
    key: "_roundToTwoAndFormat",
    value: function _roundToTwoAndFormat(num) {
      return (Math.round(num * 100) / 100).toFixed(2).replace('.', ',').replace(/,?0+$/, '');
    }
  }, {
    key: "_updateOrder",
    value: function _updateOrder() {
      if (this.mainContent) {
        var children = this.mainContent.children;
        var isMobile = window.innerWidth <= 990;
        var isPrint = window.matchMedia('print').matches;
        Array.from(children).forEach(function (child) {
          if (isMobile || isPrint) {
            if (child.classList.contains('section-article-header')) {
              child.style.order = '1';
            } else if (child.classList.contains('article-recipe-servings')) {
              child.style.order = '2';
            } else if (child.classList.contains('article-richtext')) {
              child.style.order = '3';
            } else if (child.classList.contains('article-ingridients')) {
              child.style.order = '4';
            } else {
              child.style.order = '5';
            }
          } else {
            child.style.order = '';
          }
        });

        // Apply or remove flex display on parent
        this.mainContent.style.display = isMobile || isPrint ? 'flex' : '';
        this.mainContent.style.flexDirection = isMobile || isPrint ? 'column' : '';
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-ingredients')) {
  customElements.define('ed-ingredients', EdIngredients);
}

/***/ }),

/***/ "./src/js/modules/ed-pdf-picker.js":
/*!*****************************************!*\
  !*** ./src/js/modules/ed-pdf-picker.js ***!
  \*****************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var PdfPicker = /*#__PURE__*/function (_HTMLElement) {
  function PdfPicker() {
    _classCallCheck(this, PdfPicker);
    return _callSuper(this, PdfPicker, arguments);
  }
  _inherits(PdfPicker, _HTMLElement);
  return _createClass(PdfPicker, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      this._filterDesigns(this.selectedOption);
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.designs = this.querySelectorAll('li');
      this.form = document.querySelector('form[data-type="add-to-cart-form"]');
      this.selectedOption = document.querySelector('option[selected="selected"]').value;
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      document.addEventListener('variantSelected', function (event) {
        _this._filterDesigns(event.detail.value);
      });
      this.designs.forEach(function (design) {
        design.addEventListener('click', function () {
          _this._selectDesign(design);
        });
      });
    }
  }, {
    key: "_selectDesign",
    value: function _selectDesign(design) {
      this.designs.forEach(function (d) {
        return d.classList.remove('selected');
      });
      design.classList.add('selected');
      if (this.form) {
        var input = this.form.querySelector('input[name="properties[_edPdf]"]');
        var dataSpan = design.querySelector('.ed-pdf-picker__data');
        if (dataSpan && dataSpan.dataset.url) {
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'properties[_edPdf]';
            this.form.insertBefore(input, this.form.firstChild);
          }
          input.value = dataSpan.dataset.url;
        }
      }
    }
  }, {
    key: "_filterDesigns",
    value: function _filterDesigns(selectedVariantId) {
      if (!selectedVariantId && this.selectedOption) {
        selectedVariantId = this.selectedOption.dataset.value;
      }
      if (selectedVariantId) {
        var firstVisibleDesign = null;
        this.designs.forEach(function (design) {
          if (design.dataset.value !== selectedVariantId) {
            design.setAttribute('hidden', '');
          } else {
            design.removeAttribute('hidden');
            if (!firstVisibleDesign) {
              firstVisibleDesign = design;
            }
          }
        });
        if (firstVisibleDesign) {
          this._selectDesign(firstVisibleDesign);
        }
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-pdf-picker')) {
  customElements.define('ed-pdf-picker', PdfPicker);
}

/***/ }),

/***/ "./src/js/modules/ed-popup.js":
/*!************************************!*\
  !*** ./src/js/modules/ed-popup.js ***!
  \************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var OpenPopupButton = /*#__PURE__*/function (_HTMLElement) {
  function OpenPopupButton() {
    _classCallCheck(this, OpenPopupButton);
    return _callSuper(this, OpenPopupButton, arguments);
  }
  _inherits(OpenPopupButton, _HTMLElement);
  return _createClass(OpenPopupButton, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.popup = document.querySelector('ed-popup[name="' + this.getAttribute('aria-controls') + '"]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.addEventListener('click', this.onClick.bind(this));
    }
  }, {
    key: "onClick",
    value: function onClick() {
      this.popup.setAttribute('active', 'true');
      document.body.classList.add('overflow-hidden');
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-popup-button', OpenPopupButton);
var ElbdevPopup = /*#__PURE__*/function (_HTMLElement2) {
  function ElbdevPopup() {
    _classCallCheck(this, ElbdevPopup);
    return _callSuper(this, ElbdevPopup, arguments);
  }
  _inherits(ElbdevPopup, _HTMLElement2);
  return _createClass(ElbdevPopup, [{
    key: "active",
    get: /** GETTERS AND SETTERS **/
    function get() {
      return this.getAttribute('active');
    },
    set: function set(value) {
      this.setAttribute('active', value);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.closeBtn = this.querySelector('.btn-close');
      this.closeBtn.addEventListener('click', this.onBtnClose.bind(this));
      this.addEventListener('click', this.onClickOutside.bind(this));
    }
  }, {
    key: "onBtnClose",
    value: function onBtnClose() {
      this.active = 'false';
      document.body.classList.remove('overflow-hidden');
    }
  }, {
    key: "onClickOutside",
    value: function onClickOutside(e) {
      if (e.target !== this) {
        return;
      }
      this.onBtnClose();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-popup', ElbdevPopup);

/***/ }),

/***/ "./src/js/modules/ed-pre-purchase-upsell.js":
/*!**************************************************!*\
  !*** ./src/js/modules/ed-pre-purchase-upsell.js ***!
  \**************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var PrePurchaseUpsell = /*#__PURE__*/function (_HTMLElement) {
  function PrePurchaseUpsell() {
    _classCallCheck(this, PrePurchaseUpsell);
    return _callSuper(this, PrePurchaseUpsell, arguments);
  }
  _inherits(PrePurchaseUpsell, _HTMLElement);
  return _createClass(PrePurchaseUpsell, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.card = this.querySelector('.ed-ppu__card');
      this.header = this.querySelector('.ed-ppu__card-header');
      this.atc = this.querySelector('button[data-role="atc"]');
      this.decline = this.querySelector('button[data-role="decline"]');
      this.qty = this.querySelector('input');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      document.addEventListener('ed:prepurchaseupsell:trigger', this.onTrigger.bind(this));
      this.atc.addEventListener('click', function () {
        _this._addToCard();
      });
      this.decline.addEventListener('click', function () {
        _this._closeModal();
      });
      document.addEventListener('click', function (event) {
        if (_this.card && !_this.card.contains(event.target)) {
          _this._closeModal();
        }
      });
    }
  }, {
    key: "onTrigger",
    value: function onTrigger(e) {
      this.triggerEvent = e;
      if (this._hideUpsell()) {
        this._countdown(this.header);
        this.classList.add('visible');
      }
    }
  }, {
    key: "_hideUpsell",
    value: function _hideUpsell() {
      var hideDuration = parseInt(this.getAttribute('data-hide')) || 0;
      if (hideDuration === 0) {
        return true;
      }
      var currentTime = Date.now();
      var storedTime = sessionStorage.getItem('edUpsellHideTimer');
      if (storedTime) {
        var elapsedMinutes = (currentTime - parseInt(storedTime)) / (1000 * 60);
        if (elapsedMinutes < hideDuration) {
          this._closeModal();
          return false;
        }
      }
      sessionStorage.setItem('edUpsellHideTimer', currentTime.toString());
      return true;
    }
  }, {
    key: "_closeModal",
    value: function _closeModal() {
      if (this.triggerEvent && this.triggerEvent.detail) {
        this.classList.remove('visible');
        this.triggerEvent.detail.resolve({
          success: true,
          quantity: null,
          variantId: null,
          discount: null
        });
      }
    }
  }, {
    key: "_countdown",
    value: function _countdown(header) {
      var _this2 = this;
      var text = header.textContent;
      var match = text.match(/\[(\d+)\]/);
      if (match) {
        var seconds = parseInt(match[1]);
        var updateCountdownText = function updateCountdownText() {
          var minutes = Math.floor(seconds / 60);
          var remainingSeconds = seconds % 60;
          var updatedText = text.replace(/\[\d+\]/, "".concat(minutes, ":").concat(remainingSeconds.toString().padStart(2, '0')));
          header.textContent = updatedText;
        };
        updateCountdownText();
        var intervalId = setInterval(function () {
          seconds -= 1;
          if (seconds < 0) {
            clearInterval(intervalId);
            _this2._closeModal();
            return;
          }
          updateCountdownText();
        }, 1000);
      }
    }
  }, {
    key: "_addToCard",
    value: function _addToCard() {
      if (this.triggerEvent && this.triggerEvent.detail) {
        this.classList.remove('visible');
        var variantId = this.getAttribute('data-variant-id');
        var discount = this.getAttribute('data-discount');
        var quantity = this.qty ? this.qty.value : 1;
        this.triggerEvent.detail.resolve({
          success: true,
          quantity: quantity,
          variantId: variantId,
          discount: discount
        });
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-pre-purchase-upsell', PrePurchaseUpsell);

/***/ }),

/***/ "./src/js/modules/ed-product-listing.js":
/*!**********************************************!*\
  !*** ./src/js/modules/ed-product-listing.js ***!
  \**********************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var ProductListing = /*#__PURE__*/function (_HTMLElement) {
  function ProductListing() {
    _classCallCheck(this, ProductListing);
    return _callSuper(this, ProductListing);
  }
  _inherits(ProductListing, _HTMLElement);
  return _createClass(ProductListing, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      this._setupIntersectionObserver();
      this._setupScrollHandler();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.navItems = this.querySelectorAll('.ed-product-listing-nav-item:not(.collection-nav-item)');
      this.collectionTitles = this.querySelectorAll('.ed-product-listing-collection-title');
      this.nav = this.querySelector('.ed-product-listing-nav');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      this.navItems.forEach(function (item) {
        return item.addEventListener('click', function (e) {
          return _this.handleNavItemClick(e);
        });
      });
    }
  }, {
    key: "handleNavItemClick",
    value: function handleNavItemClick(e) {
      var _this2 = this;
      this.navItems.forEach(function (item) {
        return item.classList.remove('active-nav-item');
      });
      // e.target.classList.add('active-nav-item');

      var navTitle = e.target.dataset.navTitle;
      var targetCollection = Array.from(this.collectionTitles).find(function (element) {
        return element.dataset.collectionTitle === navTitle;
      });
      if (targetCollection) {
        var offset = window.innerWidth < 750 ? 110 : 70;
        var elementPosition = targetCollection.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: elementPosition - offset,
          behavior: 'smooth'
        });
      }
      setTimeout(function () {
        return _this2._scrollNavItemIntoView(e.target);
      }, 500);
    }
  }, {
    key: "_setupIntersectionObserver",
    value: function _setupIntersectionObserver() {
      var _this3 = this;
      var offset = window.innerWidth < 750 ? 120 : 80;
      var options = {
        root: null,
        rootMargin: "".concat(offset, "px 0px -").concat(window.innerHeight - offset - 1, "px 0px"),
        threshold: 0
      };
      this.observer = new IntersectionObserver(this._handleIntersect.bind(this), options);
      this.collectionTitles.forEach(function (title) {
        _this3.observer.observe(title);
      });
    }
  }, {
    key: "_handleIntersect",
    value: function _handleIntersect(entries) {
      var _this4 = this;
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var collectionTitle = entry.target.dataset.collectionTitle;
          _this4.navItems.forEach(function (item) {
            if (item.dataset.navTitle === collectionTitle) {
              item.classList.add('active-nav-item');
            } else {
              item.classList.remove('active-nav-item');
            }
          });
        }
      });
    }
  }, {
    key: "_setupScrollHandler",
    value: function _setupScrollHandler() {
      var _this5 = this;
      var isScrolling;
      window.addEventListener('scroll', function () {
        // clear timeout throughout the scroll
        window.clearTimeout(isScrolling);
        isScrolling = setTimeout(function () {
          _this5._scrollActiveNavItemIntoView();
        }, 200);
      }, false);
    }
  }, {
    key: "_scrollActiveNavItemIntoView",
    value: function _scrollActiveNavItemIntoView() {
      var activeItem = this.querySelector('.active-nav-item');
      if (activeItem) {
        this._scrollNavItemIntoView(activeItem);
      }
    }
  }, {
    key: "_scrollNavItemIntoView",
    value: function _scrollNavItemIntoView(item) {
      var container = this.nav;
      var itemLeft = item.offsetLeft;
      var itemWidth = item.offsetWidth;
      var containerWidth = container.clientWidth;

      // calculate the desired scroll position to center the active item
      var desiredScrollLeft = itemLeft - containerWidth / 2 + itemWidth / 2;

      // ensure the desired scroll position is within valid bounds
      var maxScrollLeft = container.scrollWidth - containerWidth;
      desiredScrollLeft = Math.max(0, Math.min(desiredScrollLeft, maxScrollLeft));

      // scroll the container to the desired position
      container.scrollTo({
        left: desiredScrollLeft,
        behavior: 'smooth'
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-product-listing', ProductListing);
var MainRecipes = /*#__PURE__*/function (_HTMLElement2) {
  function MainRecipes() {
    _classCallCheck(this, MainRecipes);
    return _callSuper(this, MainRecipes);
  }
  _inherits(MainRecipes, _HTMLElement2);
  return _createClass(MainRecipes);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-main-recipes', MainRecipes);

/***/ }),

/***/ "./src/js/modules/ed-qty-discount-selector.js":
/*!****************************************************!*\
  !*** ./src/js/modules/ed-qty-discount-selector.js ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _helpers_format_money__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/format-money */ "./src/js/helpers/format-money.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }

var QuantityDiscountSelector = /*#__PURE__*/function (_HTMLElement) {
  function QuantityDiscountSelector() {
    _classCallCheck(this, QuantityDiscountSelector);
    return _callSuper(this, QuantityDiscountSelector, arguments);
  }
  _inherits(QuantityDiscountSelector, _HTMLElement);
  return _createClass(QuantityDiscountSelector, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      this.originalPrice = this.dataset.originalPrice;
      this.originalUnitPrice = this.dataset.originalUnitPrice;
      this.moneyFormat = document.body.getAttribute('data-money-format');
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.bulkPriceOptions = this.querySelectorAll('.bulk-price__option');
      this.quantityLabels = this.querySelectorAll('.bulk-price__quantity[data-index]');
      this.unitPrice = this.querySelector('[data-ed-unit-price]');
      this.quantityInput = this.parentElement.querySelector('quantity-input.quantity');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      this.bulkPriceOptions.forEach(function (item) {
        item.addEventListener('click', _this.onOptionClick.bind(_this));
      });
    }
  }, {
    key: "onOptionClick",
    value: function onOptionClick(e) {
      var _this2 = this;
      this.bulkPriceOptions.forEach(function (item) {
        if (e.currentTarget === item) {
          item.classList.add('bulk-price__option--current');
          _this2.selectItem(item);
        } else {
          item.classList.remove('bulk-price__option--current');
        }
      });
    }
  }, {
    key: "selectItem",
    value: function selectItem(item) {
      var price = parseFloat(item.dataset.price) * 100;
      var quantity = item.dataset.quantity;
      var currentIndex = item.dataset.index;
      var unitPrice = item.dataset.unitPrice;
      var comparePrice = parseInt(this.originalPrice) * quantity;
      this.updatePrice(price, comparePrice);
      if (this.unitPrice) {
        this.updateUnitPrice(unitPrice);
      }
      this.updateQuantityLabel(currentIndex);
      this.updateQuantityInput(quantity);
    }
  }, {
    key: "updateQuantityInput",
    value: function updateQuantityInput(quantity) {
      this.quantityInput.input.value = parseInt(quantity);
      //this.quantityInput.input = parseInt(quantity);
    }
  }, {
    key: "updatePrice",
    value: function updatePrice(price, comparePrice) {
      this.priceRegularContainer = this.querySelector('.price__regular');
      this.priceSaleContainer = this.querySelector('.price__sale');
      this.priceContainer = this.querySelector('.price');
      if (!this.priceRegularContainer || !this.priceSaleContainer) {
        console.warn('Price containers not found.');
        return;
      }
      if (comparePrice > price) {
        this.priceContainer.classList.add('price--on-sale');
        var saleItem = this.priceSaleContainer.querySelector('.price-item--sale');
        var regularItem = this.priceSaleContainer.querySelector('.price-item--regular');
        if (saleItem) saleItem.innerText = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(price, this.moneyFormat);
        if (regularItem) regularItem.innerText = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(comparePrice, this.moneyFormat);
      } else {
        this.priceContainer.classList.remove('price--on-sale');
        var _saleItem = this.priceRegularContainer.querySelector('.price-item--sale');
        var _regularItem = this.priceRegularContainer.querySelector('.price-item--regular');
        if (_saleItem) _saleItem.innerText = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(price, this.moneyFormat);
        if (_regularItem) _regularItem.innerText = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(comparePrice, this.moneyFormat);
      }
    }
  }, {
    key: "updateUnitPrice",
    value: function updateUnitPrice(unitprice) {
      if (this.unitPrice) {
        if (unitprice) {
          this.unitPrice.innerText = unitprice;
        } else {
          this.unitPrice.innerText = this.originalUnitPrice;
        }
      }
    }
  }, {
    key: "updateQuantityLabel",
    value: function updateQuantityLabel(selectedIndex) {
      selectedIndex = parseInt(selectedIndex);
      this.quantityLabels.forEach(function (item, index) {
        if (selectedIndex === index + 1) {
          item.classList.add('current');
        } else {
          item.classList.remove('current');
        }
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-qty-discount-selector')) {
  customElements.define('ed-qty-discount-selector', QuantityDiscountSelector);
}

/***/ }),

/***/ "./src/js/modules/ed-quick-add.js":
/*!****************************************!*\
  !*** ./src/js/modules/ed-quick-add.js ***!
  \****************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var EdQuickAddHandler = /*#__PURE__*/function (_HTMLElement) {
  function EdQuickAddHandler() {
    _classCallCheck(this, EdQuickAddHandler);
    return _callSuper(this, EdQuickAddHandler, arguments);
  }
  _inherits(EdQuickAddHandler, _HTMLElement);
  return _createClass(EdQuickAddHandler, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.cart = document.querySelector('cart-drawer');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('click', this.onClick.bind(this));
    }
  }, {
    key: "onClick",
    value: function onClick(e) {
      var button = e.target.closest('[data-ed-quick-add-btn]');
      if (!button) {
        return;
      }
      this.addToCart(button);
    }
  }, {
    key: "addToCart",
    value: function addToCart(button) {
      var _this = this;
      button.disabled = true;
      button.classList.add('loading');
      var loadingSpinOverlay = button.querySelector('.loading-overlay__spinner');
      loadingSpinOverlay === null || loadingSpinOverlay === void 0 || loadingSpinOverlay.classList.remove('hidden');
      this.addVariantToCart(button.dataset.variantId).then(function () {
        button.disabled = false;
        button.classList.remove('loading');
        loadingSpinOverlay === null || loadingSpinOverlay === void 0 || loadingSpinOverlay.classList.add('hidden');
        if (_this.cart.classList.contains('is-empty')) {
          _this.cart.classList.remove('is-empty');
        }
      });
    }
  }, {
    key: "addVariantToCart",
    value: function () {
      var _addVariantToCart = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(id) {
        var config, formData, response, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              config = {
                method: "POST",
                headers: {
                  "X-Requested-With": "XMLHttpRequest"
                },
                body: null
              };
              formData = new FormData();
              formData.append('sections', this.cart.getSectionsToRender().map(function (section) {
                return section.id;
              }));
              formData.append('sections_url', window.location.pathname);
              //formData.append('properties[_ed-cart-upsell]', 'true');

              // Append item details into the FormData
              formData.append('items[0][id]', id);
              formData.append('items[0][quantity]', '1');
              //formData.append('items[0][properties][_ed-cart-upsell]', 'true');
              this.cart.setActiveElement(document.activeElement);
              config.body = formData;
              _context.prev = 8;
              _context.next = 11;
              return fetch(window.Shopify.routes.root + 'cart/add.js', config);
            case 11:
              response = _context.sent;
              _context.next = 14;
              return response.json();
            case 14:
              result = _context.sent;
              this.cart.renderContents(result);
              _context.next = 22;
              break;
            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](8);
              console.error('Error:', _context.t0);
              throw _context.t0;
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[8, 18]]);
      }));
      function addVariantToCart(_x) {
        return _addVariantToCart.apply(this, arguments);
      }
      return addVariantToCart;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-quick-add-handler', EdQuickAddHandler);

/***/ }),

/***/ "./src/js/modules/ed-scroll-to-top.js":
/*!********************************************!*\
  !*** ./src/js/modules/ed-scroll-to-top.js ***!
  \********************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var ScrollToTop = /*#__PURE__*/function (_HTMLElement) {
  function ScrollToTop() {
    _classCallCheck(this, ScrollToTop);
    return _callSuper(this, ScrollToTop, arguments);
  }
  _inherits(ScrollToTop, _HTMLElement);
  return _createClass(ScrollToTop, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachListeners();
      // No need to call _initScrollUpButton() anymore
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      this.addEventListener('click', this._scrollToTop);
      window.addEventListener('scroll', function () {
        return _this._toggleButtonVisibility();
      });
    }
  }, {
    key: "_hideButton",
    value: function _hideButton() {
      this.classList.remove('visible');
    }
  }, {
    key: "_showButton",
    value: function _showButton() {
      this.classList.add('visible');
    }
  }, {
    key: "_scrollToTop",
    value: function _scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, {
    key: "_toggleButtonVisibility",
    value: function _toggleButtonVisibility() {
      if (window.pageYOffset > 200) {
        this._showButton();
      } else {
        this._hideButton();
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-scroll-to-top')) {
  customElements.define('ed-scroll-to-top', ScrollToTop);
}

/***/ }),

/***/ "./src/js/modules/ed-table-of-content.js":
/*!***********************************************!*\
  !*** ./src/js/modules/ed-table-of-content.js ***!
  \***********************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var TableOfContent = /*#__PURE__*/function (_HTMLElement) {
  function TableOfContent() {
    _classCallCheck(this, TableOfContent);
    return _callSuper(this, TableOfContent, arguments);
  }
  _inherits(TableOfContent, _HTMLElement);
  return _createClass(TableOfContent, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      this._initializeTableOfContent();
      this._initializeAccordion();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.tableOfContentScroll = this.querySelector('.article-template__table-of-content__indicator');
      this.tableOfContent = this.querySelector('.header__table-of-content');
      this.tableOfContentItems = document.querySelectorAll('.article__page .table-of-contents__item');
      this.accordionHeader = this.querySelector('h5');
      this.accordionContent = this.querySelector('.header__table-of-content');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      this.addEventListener('click', function (event) {
        var item = event.target.closest('.article__table-of-content-item');
        if (item) {
          _this._scrollToView(item.dataset.target);
        }
      });
      window.addEventListener('scroll', this._throttle(this._scrollCallback.bind(this)));
      if (this.classList.contains('ed-table-of-content')) {
        this.accordionHeader.addEventListener('click', this._toggleAccordion.bind(this));
        window.addEventListener('resize', this._handleResize.bind(this));
      }
    }
  }, {
    key: "_initializeTableOfContent",
    value: function _initializeTableOfContent() {
      var _this2 = this;
      var itemIndex = 1;
      this.tableOfContentItems.forEach(function (tableOfContentItem) {
        var sectionElement = tableOfContentItem.closest('section');
        var includeTextContentH2s = sectionElement.dataset.includeH2 === 'true';
        var includeTextContentH3s = sectionElement.dataset.includeH3 === 'true';
        var hideH3s = document.querySelector('[data-ed-hide-h3s]').dataset.edHideH3s === 'true';
        var headings = tableOfContentItem.querySelectorAll('h2, h3');
        headings.forEach(function (item) {
          // Skip if the heading is inside an element with the 'faq' class
          if (item.closest('.faq')) return;
          var isH2 = item.tagName === 'H2';
          var isH3 = item.tagName === 'H3';

          // Skip h3s if hideH3s is true
          if (isH3 && hideH3s) return;

          // Do not add headings from text content if conditions are not met
          var isInTextContent = item.closest('[data-ed-text-content]');
          if (isH2 && !includeTextContentH2s && isInTextContent) return;
          if (isH3 && !includeTextContentH3s && isInTextContent) return;
          var contentItem = _this2._createTableOfContentItem(item, isH2 ? itemIndex : null);
          _this2.tableOfContent.appendChild(contentItem);
          if (isH2) {
            itemIndex += 1;
          }
        });
      });
      this.sectionIds = this.querySelectorAll('.article__card.article__table-of-content-item');
      this.articleItems = [];
      this.sectionIds.forEach(function (section) {
        var articleItem = document.querySelector("#".concat(section.dataset.target));
        _this2.articleItems.push(articleItem);
      });
    }
  }, {
    key: "_scrollToView",
    value: function _scrollToView(id) {
      var article = document.getElementById(id);
      var header = document.getElementById('shopify-section-header');
      var scrollTimeOut = setTimeout(function () {
        if (window.innerWidth <= 899) {
          var headerHeight = header ? header.offsetHeight : 0;
          window.scrollTo(0, article.offsetTop - headerHeight);
        } else {
          window.scrollTo(0, article.offsetTop);
        }
        clearTimeout(scrollTimeOut);
      }, 300);
    }
  }, {
    key: "_updateIndicator",
    value: function _updateIndicator(element) {
      var sectionPosition = element.getBoundingClientRect();
      if (sectionPosition.top <= 150) {
        var activeTab = this.querySelector("[data-target=\"".concat(element.id, "\"]"));
        this.tableOfContentScroll.style.top = "".concat(activeTab.offsetTop, "px");
      }
    }
  }, {
    key: "_scrollCallback",
    value: function _scrollCallback() {
      var _this3 = this;
      if (!window.matchMedia('(min-width: 990px)').matches) return;
      this.articleItems.forEach(function (item) {
        return _this3._updateIndicator(item);
      });
      var relatedPosts = document.querySelector('[id$="__related_posts"]');
      if (!relatedPosts) return;
      var sidebar = this.closest("[id*=__table_of_content]");
      if (relatedPosts.getBoundingClientRect().top <= sidebar.getBoundingClientRect().height) {
        sidebar.style.top = "".concat(relatedPosts.getBoundingClientRect().top - sidebar.getBoundingClientRect().height, "px");
      } else {
        sidebar.style.top = null;
      }
    }
  }, {
    key: "_throttle",
    value: function _throttle(callback) {
      var requestId = null;
      var lastArgs;
      var later = function later(context) {
        return function () {
          requestId = null;
          callback.apply(context, lastArgs);
        };
      };
      var throttled = function throttled() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        lastArgs = args;
        if (requestId === null) {
          requestId = requestAnimationFrame(later(this));
        }
      };
      throttled.cancel = function () {
        cancelAnimationFrame(requestId);
        requestId = null;
      };
      return throttled;
    }
  }, {
    key: "_createTableOfContentItem",
    value: function _createTableOfContentItem(element) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var container = document.createElement('div');
      container.classList.add('article__card', 'article__table-of-content-item');
      var contentDesc = document.createElement('div');
      contentDesc.classList.add('article-template__content-desc');
      var span = document.createElement('span');
      span.innerText = element.textContent;
      span.classList.add('article-template__content-title', 'font__body-small-bold');
      var descSpan = document.createElement('span');
      descSpan.classList.add('article__template-desc', 'font__body-small');
      descSpan.innerHTML = element.dataset.description || '';
      var indexSpan = document.createElement('span');
      indexSpan.innerHTML = index >= 0 ? index : '';
      indexSpan.classList.add('article__card__button-index');
      if (index === null) {
        indexSpan.classList.add('bg-white');
        container.classList.add("sub-item");
      } else {
        container.classList.add("main-item");
      }
      container.appendChild(indexSpan);
      contentDesc.appendChild(span);
      contentDesc.appendChild(descSpan);
      container.appendChild(contentDesc);
      container.dataset.target = element.closest('section').id;
      return container;
    }
  }, {
    key: "_initializeAccordion",
    value: function _initializeAccordion() {
      if (this.classList.contains('ed-table-of-content')) {
        this._updateAccordionState();
      }
    }
  }, {
    key: "_toggleAccordion",
    value: function _toggleAccordion() {
      if (this.classList.contains('ed-table-of-content') && window.innerWidth <= 899) {
        var isOpen = this.accordionContent.style.display === 'block';
        this.accordionContent.style.display = isOpen ? 'none' : 'block';
        if (this.accordionHeader.classList.contains('ed-table-of-content__acordion-closed')) {
          this.accordionHeader.classList.remove('ed-table-of-content__acordion-closed');
        } else {
          this.accordionHeader.classList.add('ed-table-of-content__acordion-closed');
        }
      }
    }
  }, {
    key: "_handleResize",
    value: function _handleResize() {
      if (this.classList.contains('ed-table-of-content')) {
        this._updateAccordionState();
      }
    }
  }, {
    key: "_updateAccordionState",
    value: function _updateAccordionState() {
      var isMobile = window.innerWidth <= 899;
      this.accordionContent.style.display = isMobile ? 'none' : 'block';
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-table-of-content')) {
  customElements.define('ed-table-of-content', TableOfContent);
}

/***/ }),

/***/ "./src/js/modules/ed-testimonials-slider.js":
/*!**************************************************!*\
  !*** ./src/js/modules/ed-testimonials-slider.js ***!
  \**************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var TestimonialSlider = /*#__PURE__*/function (_HTMLElement) {
  function TestimonialSlider() {
    var _this;
    _classCallCheck(this, TestimonialSlider);
    _this = _callSuper(this, TestimonialSlider);
    _this.swiper = null;
    // Track the current mode ("mobile" or "desktop")
    _this.currentMode = null;
    _this.handleResize = _this.handleResize.bind(_this);
    return _this;
  }
  _inherits(TestimonialSlider, _HTMLElement);
  return _createClass(TestimonialSlider, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      document.addEventListener('DOMContentLoaded', function () {
        _this2.initSwiperForCurrentSize();
      });
      window.addEventListener('resize', this.handleResize);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      this.destroySwiper();
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      var isMobile = window.innerWidth <= 749;
      var newMode = isMobile ? 'mobile' : 'desktop';
      // Only reinitialize if the mode has changed
      if (newMode !== this.currentMode) {
        this.destroySwiper();
        this.initSwiperForCurrentSize();
      }
    }
  }, {
    key: "initSwiperForCurrentSize",
    value: function initSwiperForCurrentSize() {
      var isMobile = window.innerWidth <= 749;
      this.currentMode = isMobile ? 'mobile' : 'desktop';
      if (isMobile) {
        this.initMobileSwiper();
      } else {
        this.initDesktopSwiper();
      }
    }
  }, {
    key: "initMobileSwiper",
    value: function initMobileSwiper() {
      this.swiper = new Swiper(this.querySelector('ed-testimonial-slider .swiper-container'), {
        effect: "coverflow",
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev')
        },
        grabCursor: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 160,
          depth: 200,
          modifier: 1,
          slideShadows: true
        },
        keyboard: {
          enabled: true
        }
      });
    }
  }, {
    key: "initDesktopSwiper",
    value: function initDesktopSwiper() {
      this.swiper = new Swiper(this.querySelector('ed-testimonial-slider .swiper-container'), {
        slidesPerView: 3,
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev')
        },
        observer: true,
        observeParents: true,
        centeredSlides: false,
        effect: 'slide',
        spaceBetween: 20
      });
    }
  }, {
    key: "destroySwiper",
    value: function destroySwiper() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-testimonial-slider')) {
  customElements.define('ed-testimonial-slider', TestimonialSlider);
}

/***/ }),

/***/ "./src/js/modules/ed-toast-notifications.js":
/*!**************************************************!*\
  !*** ./src/js/modules/ed-toast-notifications.js ***!
  \**************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var ToastNotifications = /*#__PURE__*/function (_HTMLElement) {
  function ToastNotifications() {
    _classCallCheck(this, ToastNotifications);
    return _callSuper(this, ToastNotifications, arguments);
  }
  _inherits(ToastNotifications, _HTMLElement);
  return _createClass(ToastNotifications, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.container = this.querySelector('.ed-toast-notification-container');
      this.duration = this.dataset.toastDuration;
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('ed:toast:notification:trigger', this.onTrigger.bind(this));
    }
  }, {
    key: "onTrigger",
    value: function onTrigger(e) {
      var settings = e.detail;
      var duration = this.duration != null ? this.duration : settings.duration != null ? settings.duration : 3000;
      var text = settings.text != null ? settings.text : '';
      var type = settings.type != null ? settings.type : 'info';
      this.showNotification(text, type, duration);
    }
  }, {
    key: "showNotification",
    value: function showNotification(text, type, duration) {
      var _this = this;
      // Create a new notification element
      var notification = document.createElement('div');
      notification.classList.add('ed-toast-notification');
      notification.classList.add('font__body-extra-small');
      notification.classList.add("type-".concat(type));
      notification.innerText = text;

      // Prepend the new notification to the container at the top
      this.container.prepend(notification);

      // Get all existing notifications and calculate their positions
      var existingNotifications = this.container.querySelectorAll('.ed-toast-notification');
      existingNotifications.forEach(function (notif, index) {
        if (!notif.hasAttribute('positioned')) {
          // Only update unpositioned notifications
          notif.style.transform = "translateY(".concat(index, "px)");
          notif.setAttribute('positioned', 'true');
        }
      });

      // Remove the notification after the given duration
      setTimeout(function () {
        _this.closeNotification(notification);
      }, duration);
    }
  }, {
    key: "closeNotification",
    value: function closeNotification(notification) {
      var _this2 = this;
      // Fade out and slide up the notification
      notification.style.opacity = '0';
      notification.style.transform = 'translateY(-100%)';

      // Remove the notification from the DOM after the transition
      setTimeout(function () {
        if (notification.parentElement) {
          _this2.container.removeChild(notification);

          // Adjust remaining notifications to move up and fill the gap
          var remainingNotifications = _this2.container.querySelectorAll('.ed-toast-notification');
          remainingNotifications.forEach(function (notif, index) {
            notif.style.transform = "translateY(".concat(index, "px)");
          });
        }
      }, 1000);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-toast-notifications', ToastNotifications);

/***/ }),

/***/ "./src/js/modules/ed-variant-dropdown.js":
/*!***********************************************!*\
  !*** ./src/js/modules/ed-variant-dropdown.js ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _helpers_format_money__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/format-money */ "./src/js/helpers/format-money.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }

var VariantDropdown = /*#__PURE__*/function (_HTMLElement) {
  function VariantDropdown() {
    var _this;
    _classCallCheck(this, VariantDropdown);
    _this = _callSuper(this, VariantDropdown);
    _this._handleDocumentClick = _this._handleDocumentClick.bind(_this);
    return _this;
  }
  _inherits(VariantDropdown, _HTMLElement);
  return _createClass(VariantDropdown, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      var _this2 = this;
      this.dropdownToggle = this.querySelector('.ed-variant-dropdown');
      this.dropdownContent = this.querySelector('.dropdown-variant-selection');
      this.variantItems = this.querySelectorAll('.dropdown-variant-wrapper');
      this.colors = this.querySelectorAll('.ed-variant-dropdown-color');
      this.closeIcon = this.querySelector('.ed-close-icon');
      this.dropdown = this.querySelector('.ed-variant-dropdown');
      this.accordionContent = this.closest('.accordion__content');
      this.card = this.closest('.card');
      if (this.card) {
        this.quickAddWrapper = this.card.querySelector('.ed-quick-add-wrapper[data-ed-quick-add]');
        this.quickAddButton = this.card.querySelector('.quick-add__submit[data-ed-quick-add-btn]');
      }
      if (!this.card) {
        this.variantItems.forEach(function (item) {
          _this2.hideSelectedVariant(item);
        });
      }
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this3 = this;
      this.dropdownToggle.addEventListener('click', function () {
        return _this3.toggleDropdown();
      });
      this.variantItems.forEach(function (item) {
        item.addEventListener('click', function (e) {
          _this3.handleItemClick(e);
          if (_this3.card) {
            _this3.handleCardItemClick(e);
          } else {
            _this3.handleIngredientItemClick(e); // ingredients dropdown
          }
          _this3.closeDropdown();
        });
      });
      if (this.closeIcon) {
        this.closeIcon.addEventListener('click', function () {
          return _this3.closeDropdown();
        });
      }
    }
  }, {
    key: "handleCardItemClick",
    value: function handleCardItemClick(e) {
      var variantWrapper = e.target.closest('.dropdown-variant-wrapper');
      var id = variantWrapper.dataset.variantId;
      var title = variantWrapper.dataset.productName;
      var color = variantWrapper.dataset.color;
      var image = variantWrapper.dataset.image;
      var price = variantWrapper.dataset.price;
      var compareAtPrice = variantWrapper.dataset.compareAtPrice;
      var bulkComparePrice = variantWrapper.dataset.bulkComparePrice;
      var unitPrice = variantWrapper.dataset.unitPrice;
      var productReview = variantWrapper.dataset.productReview;
      var shortName = variantWrapper.dataset.shortName;
      var url = variantWrapper.dataset.productUrl;
      var available = variantWrapper.dataset.available;

      // update button state
      if (available === 'true' && this.quickAddWrapper) {
        this.quickAddWrapper.removeAttribute('disabled');
        this.quickAddButton.innerText = this.getAttribute('btn-text-atc');
        this.quickAddButton.dataset.variantId = id;
      } else if (available === 'false' && this.quickAddWrapper) {
        this.quickAddWrapper.setAttribute('disabled', '');
        this.quickAddButton.innerText = this.getAttribute('btn-text-sold-out');
        this.quickAddButton.dataset.variantId = id;
      }

      // remove & add checkmark
      this.colors.forEach(function (color) {
        return color.classList.remove('selected-variant');
      });
      variantWrapper.querySelector('.ed-variant-dropdown-color').classList.add('selected-variant');
      if (id) {
        this.card.querySelector('.ed-variant-dropdown').setAttribute('data-selected-variant-id', id);
        this.card.querySelector('.scf_id').setAttribute('value', id);
      }
      if (title) {
        this.card.querySelector('.card__title').innerText = title;
      }
      if (bulkComparePrice && bulkComparePrice > price) {
        bulkComparePrice = parseFloat(bulkComparePrice).toFixed(2);
        this.card.querySelector('.ed-price').classList.add('price--on-sale');
        this.card.querySelector('.ed-price .price__regular').style.display = 'none';
        this.card.querySelector('.ed-price .price__sale .price-item--sale').innerText = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(price, document.body.getAttribute('data-money-format'));
        this.card.querySelector('.ed-price .price__sale .price-item--regular').innerText = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(bulkComparePrice, document.body.getAttribute('data-money-format'));
        this.card.querySelector('.ed-price .price__sale').style.display = 'block';
      } else if (bulkComparePrice && bulkComparePrice <= price) {
        this.card.querySelector('.ed-price').classList.remove('price--on-sale');
        this.card.querySelector('.price-item').innerHTML = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(price, document.body.getAttribute('data-money-format')) + '<span>*</span>';
        this.card.querySelector('.ed-price .price__sale').style.display = 'none';
        this.card.querySelector('.ed-price .price__regular').style.display = 'block';
      } else if (price) {
        if (compareAtPrice && compareAtPrice > price) {
          this.card.querySelector('.ed-price').classList.add('price--on-sale');
          this.card.querySelector('.ed-price .price__regular').style.display = 'none';
          this.card.querySelector('.ed-price .price__sale .price-item--sale').innerText = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(price, document.body.getAttribute('data-money-format'));
          this.card.querySelector('.ed-price .price__sale .price-item--regular').innerText = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(compareAtPrice, document.body.getAttribute('data-money-format'));
          this.card.querySelector('.ed-price .price__sale').style.display = 'block';
        } else {
          this.card.querySelector('.ed-price').classList.remove('price--on-sale');
          this.card.querySelector('.price-item').innerHTML = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(price, document.body.getAttribute('data-money-format')) + '<span>*</span>';
          this.card.querySelector('.ed-price .price__sale').style.display = 'none';
          this.card.querySelector('.ed-price .price__regular').style.display = 'block';
        }
      }
      if (unitPrice) {
        this.card.querySelector('[data-ed-unit-price]').innerText = unitPrice;
      }
      if (url) {
        this.card.querySelector('.card__title').href = url;
      }
      if (productReview) {
        this.card.querySelector('.card-information').innerText = productReview;
      }
      if (color) {
        this.card.querySelector('.ed-variant-dropdown-color').style.background = color;
      }
      if (shortName) {
        this.card.querySelector('.ed-variant-dropdown-product').innerText = shortName;
      }
      if (image) {
        this.card.querySelector('.card__media img').src = image;
        this.card.querySelector('.card__media img').srcset = image;
      }
    }
  }, {
    key: "handleIngredientItemClick",
    value: function handleIngredientItemClick(e) {
      var _this4 = this;
      var variantWrapper = e.target.closest('.dropdown-variant-wrapper');
      if (!variantWrapper) return;
      var shortName = variantWrapper.dataset.shortName;
      var name = variantWrapper.dataset.productName;
      var color = variantWrapper.dataset.color;
      var tables = document.querySelectorAll('[data-ingredients-table]');
      var selectedIngredient = document.querySelector('ed-ingredients-dropdown .ed-selected-ingredient').innerText;
      var selectedVariant = document.querySelector('[data-selected-variant]');
      selectedVariant.dataset.selectedVariant = name;
      if (this.dropdown) {
        this.dropdown.querySelector('.ed-variant-dropdown-product').innerText = shortName;
        this.dropdown.querySelector('.ed-variant-dropdown-color').style.background = color;
      }
      this.variantItems.forEach(function (item) {
        item.classList.remove('hidden');
        _this4.colors.forEach(function (color) {
          return color.classList.remove('selected-variant');
        });
        _this4.hideSelectedVariant(item, selectedVariant.dataset.selectedVariant);
      });
      if (selectedIngredient) {
        // zutaten & nährwerte tab - show/hide tables
        tables.forEach(function (table) {
          var isMatch = table.dataset.ingredientsProduct === name && table.dataset.ingredientsTable === selectedIngredient;
          table.classList.toggle('hidden', !isMatch);
        });
      }
      if (this.accordionContent) {
        this.getAccordionContent(name);
      }
    }
  }, {
    key: "handleItemClick",
    value: function handleItemClick(e) {
      if (this.card) {// card product
      } else {// ingredients tab
      }
    }
  }, {
    key: "getAccordionContent",
    value: function getAccordionContent(name) {
      // hide all content elements
      this.accordionContent.querySelectorAll('[data-tab-content]').forEach(function (content) {
        if (!content.classList.contains('hidden')) {
          content.classList.add('hidden');
        }
      });

      // create a Set to keep track of content that has been shown
      var shownContent = new Set();

      // show matching content, ensuring duplicates are only displayed once
      this.accordionContent.querySelectorAll("[data-tab-content][data-tab-product=\"".concat(name, "\"]")).forEach(function (content) {
        var contentKey = content.dataset.contentId || content.innerHTML.trim();
        if (!shownContent.has(contentKey)) {
          if (content.classList.contains('hidden')) {
            content.classList.remove('hidden');
          }
          shownContent.add(contentKey);
        }
      });
    }
  }, {
    key: "toggleDropdown",
    value: function toggleDropdown() {
      var isDisplayed = this.dropdownContent.style.display === 'block';
      if (isDisplayed) {
        this.closeDropdown();
      } else {
        this.openDropdown();
      }
    }
  }, {
    key: "hideSelectedVariant",
    value: function hideSelectedVariant(item, selectedVariant) {
      var variant = this.dropdownToggle.querySelector('[data-selected-variant]').dataset.selectedVariant;
      if (selectedVariant) {
        variant = selectedVariant;
      }
      if (item.dataset.productName === variant) {
        item.classList.add('hidden');
      }
    }
  }, {
    key: "_handleDocumentClick",
    value: function _handleDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.closeDropdown();
      }
    }
  }, {
    key: "openDropdown",
    value: function openDropdown() {
      this.dropdownContent.style.display = 'block';
      this.dropdownToggle.setAttribute('open', '');
      document.addEventListener('click', this._handleDocumentClick, true);
    }
  }, {
    key: "closeDropdown",
    value: function closeDropdown() {
      this.dropdownContent.style.display = 'none';
      this.dropdownToggle.removeAttribute('open');
      document.removeEventListener('click', this._handleDocumentClick, true);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-variant-dropdown', VariantDropdown);

/***/ }),

/***/ "./src/js/modules/ed-variant-selects.js":
/*!**********************************************!*\
  !*** ./src/js/modules/ed-variant-selects.js ***!
  \**********************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var EdVariantSelects = /*#__PURE__*/function (_HTMLElement) {
  function EdVariantSelects() {
    var _this;
    _classCallCheck(this, EdVariantSelects);
    _this = _callSuper(this, EdVariantSelects);
    _this.selectElement = _this.querySelector('select');
    _this.options = Array.from(_this.selectElement.options);
    return _this;
  }
  _inherits(EdVariantSelects, _HTMLElement);
  return _createClass(EdVariantSelects, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._createCustomDropdown();
      this._attachListeners();
    }
  }, {
    key: "_createCustomDropdown",
    value: function _createCustomDropdown() {
      var _this2 = this;
      var wrapper = document.createElement('div');
      wrapper.className = 'ed-select-wrapper';
      var selectedOption = document.createElement('div');
      selectedOption.className = 'ed-selected-option';
      selectedOption.textContent = this.selectElement.options[this.selectElement.selectedIndex].text;
      var optionsList = document.createElement('ul');
      optionsList.className = 'ed-options-list';
      this.options.forEach(function (option, index) {
        var listItem = document.createElement('li');
        listItem.className = 'ed-option';
        listItem.innerHTML = option.innerHTML;
        listItem.dataset.value = option.value;
        if (index === _this2.selectElement.selectedIndex) {
          listItem.classList.add('selected');
        }
        optionsList.appendChild(listItem);
      });
      var closeButton = document.createElement('div');
      closeButton.className = 'ed-close-button';
      wrapper.appendChild(selectedOption);
      wrapper.appendChild(optionsList);
      wrapper.appendChild(closeButton);
      this.selectElement.style.display = 'none';
      this.appendChild(wrapper);
      this.customDropdown = wrapper;
      this.selectedOptionElement = selectedOption;
      this.optionsListElement = optionsList;
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this3 = this;
      this.selectedOptionElement.addEventListener('click', function () {
        _this3.customDropdown.classList.toggle('open');
      });
      this.optionsListElement.addEventListener('click', function (event) {
        if (event.target.classList.contains('ed-option')) {
          var selectedValue = event.target.dataset.value;
          _this3.selectElement.value = selectedValue;
          _this3.selectedOptionElement.textContent = event.target.textContent;
          _this3.optionsListElement.querySelectorAll('.ed-option').forEach(function (option) {
            option.classList.toggle('selected', option.dataset.value === selectedValue);
          });
          _this3.customDropdown.classList.remove('open');
          _this3.selectElement.dispatchEvent(new Event('change', {
            bubbles: true
          }));
          document.dispatchEvent(new CustomEvent('variantSelected', {
            detail: {
              value: selectedValue
            }
          }));
        }
      });
      this.customDropdown.querySelector('.ed-close-button').addEventListener('click', function (event) {
        event.stopPropagation();
        _this3.customDropdown.classList.remove('open');
      });
      document.addEventListener('click', function (event) {
        if (!_this3.contains(event.target)) {
          _this3.customDropdown.classList.remove('open');
        }
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-variant-selects')) {
  customElements.define('ed-variant-selects', EdVariantSelects);
}

/***/ }),

/***/ "./src/js/overrides/quick-add.js":
/*!***************************************!*\
  !*** ./src/js/overrides/quick-add.js ***!
  \***************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', /*#__PURE__*/function (_ModalDialog) {
    function QuickAddModal() {
      var _this;
      _classCallCheck(this, QuickAddModal);
      _this = _callSuper(this, QuickAddModal);
      _this.modalContent = _this.querySelector('[id^="QuickAddInfo-"]');
      _this.addEventListener('product-info:loaded', function (_ref) {
        var target = _ref.target;
        target.addPreProcessCallback(_this.preprocessHTML.bind(_this));
      });
      return _this;
    }
    _inherits(QuickAddModal, _ModalDialog);
    return _createClass(QuickAddModal, [{
      key: "hide",
      value: function hide() {
        var preventFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';
        if (preventFocus) this.openedBy = null;
        _superPropGet(QuickAddModal, "hide", this, 3)([]);
      }
    }, {
      key: "show",
      value: function show(opener) {
        var _this2 = this;
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');
        fetch(opener.getAttribute('data-product-url')).then(function (response) {
          return response.text();
        }).then(function (responseText) {
          var responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          var productElement = responseHTML.querySelector('product-info');
          _this2.preprocessHTML(productElement);
          HTMLUpdateUtility.setInnerHTML(_this2.modalContent, productElement.outerHTML);
          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) window.ProductModel.loadShopifyXR();
          _superPropGet(QuickAddModal, "show", _this2, 3)([opener]);
        })["finally"](function () {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading__spinner').classList.add('hidden');
        });
      }
    }, {
      key: "preprocessHTML",
      value: function preprocessHTML(productElement) {
        var _this3 = this;
        productElement.classList.forEach(function (classApplied) {
          if (classApplied.startsWith('color-') || classApplied === 'gradient') _this3.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }
    }, {
      key: "preventVariantURLSwitching",
      value: function preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }
    }, {
      key: "removeDOMElements",
      value: function removeDOMElements(productElement) {
        var pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();
        var productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();
        var modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach(function (modal) {
          return modal.remove();
        });
      }
    }, {
      key: "preventDuplicatedIDs",
      value: function preventDuplicatedIDs(productElement) {
        var sectionId = productElement.dataset.section;
        var oldId = sectionId;
        var newId = "quickadd-".concat(sectionId);
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach(function (attribute) {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });
        productElement.dataset.originalSection = sectionId;
      }
    }, {
      key: "removeGalleryListSemantic",
      value: function removeGalleryListSemantic(productElement) {
        var galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;
        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach(function (li) {
          return li.setAttribute('role', 'presentation');
        });
      }
    }, {
      key: "updateImageSizes",
      value: function updateImageSizes(productElement) {
        var product = productElement.querySelector('.product');
        var desktopColumns = product === null || product === void 0 ? void 0 : product.classList.contains('product--columns');
        if (!desktopColumns) return;
        var mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;
        var mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }
        mediaImages.forEach(function (img) {
          return img.setAttribute('sizes', mediaImageSizes);
        });
      }
    }]);
  }(ModalDialog));
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!**************************!*\
  !*** ./src/js/custom.js ***!
  \**************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _overrides_quick_add__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./overrides/quick-add */ "./src/js/overrides/quick-add.js");
/* harmony import */ var _overrides_quick_add__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_overrides_quick_add__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _modules_ed_popup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/ed-popup */ "./src/js/modules/ed-popup.js");
/* harmony import */ var _modules_ed_popup__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_popup__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _modules_ed_countdown_announcement__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./modules/ed-countdown-announcement */ "./src/js/modules/ed-countdown-announcement.js");
/* harmony import */ var _modules_ed_countdown_announcement__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_countdown_announcement__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _modules_ed_product_listing__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modules/ed-product-listing */ "./src/js/modules/ed-product-listing.js");
/* harmony import */ var _modules_ed_product_listing__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_product_listing__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _modules_ed_article_popup_video__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./modules/ed-article-popup-video */ "./src/js/modules/ed-article-popup-video.js");
/* harmony import */ var _modules_ed_article_popup_video__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_article_popup_video__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _modules_ed_variant_dropdown__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./modules/ed-variant-dropdown */ "./src/js/modules/ed-variant-dropdown.js");
/* harmony import */ var _modules_ed_ingredients_dropdown__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./modules/ed-ingredients-dropdown */ "./src/js/modules/ed-ingredients-dropdown.js");
/* harmony import */ var _modules_ed_ingredients_dropdown__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_ingredients_dropdown__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _modules_ed_cart_outbrain_cid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./modules/ed-cart-outbrain-cid */ "./src/js/modules/ed-cart-outbrain-cid.js");
/* harmony import */ var _modules_ed_cart_outbrain_cid__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_cart_outbrain_cid__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _modules_ed_article_header_buttons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./modules/ed-article-header-buttons */ "./src/js/modules/ed-article-header-buttons.js");
/* harmony import */ var _modules_ed_article_header_buttons__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_article_header_buttons__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _modules_ed_article_upsells__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./modules/ed-article-upsells */ "./src/js/modules/ed-article-upsells.js");
/* harmony import */ var _modules_ed_article_upsells__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_article_upsells__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _modules_ed_ingredients__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./modules/ed-ingredients */ "./src/js/modules/ed-ingredients.js");
/* harmony import */ var _modules_ed_ingredients__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_ingredients__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _modules_ed_cart_upsells__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./modules/ed-cart-upsells */ "./src/js/modules/ed-cart-upsells.js");
/* harmony import */ var _modules_ed_cart_upsells__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_cart_upsells__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _modules_ed_cart_progress__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./modules/ed-cart-progress */ "./src/js/modules/ed-cart-progress.js");
/* harmony import */ var _modules_ed_toast_notifications__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./modules/ed-toast-notifications */ "./src/js/modules/ed-toast-notifications.js");
/* harmony import */ var _modules_ed_toast_notifications__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_toast_notifications__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _modules_ed_table_of_content__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./modules/ed-table-of-content */ "./src/js/modules/ed-table-of-content.js");
/* harmony import */ var _modules_ed_table_of_content__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_table_of_content__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _modules_ed_blog_slider__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./modules/ed-blog-slider */ "./src/js/modules/ed-blog-slider.js");
/* harmony import */ var _modules_ed_blog_slider__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_blog_slider__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _modules_ed_pdf_picker__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./modules/ed-pdf-picker */ "./src/js/modules/ed-pdf-picker.js");
/* harmony import */ var _modules_ed_pdf_picker__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_pdf_picker__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _modules_ed_variant_selects__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./modules/ed-variant-selects */ "./src/js/modules/ed-variant-selects.js");
/* harmony import */ var _modules_ed_variant_selects__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_variant_selects__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _modules_ed_featured_products__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./modules/ed-featured-products */ "./src/js/modules/ed-featured-products.js");
/* harmony import */ var _modules_ed_featured_products__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_featured_products__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _modules_ed_testimonials_slider__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./modules/ed-testimonials-slider */ "./src/js/modules/ed-testimonials-slider.js");
/* harmony import */ var _modules_ed_testimonials_slider__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_testimonials_slider__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _modules_ed_scroll_to_top__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./modules/ed-scroll-to-top */ "./src/js/modules/ed-scroll-to-top.js");
/* harmony import */ var _modules_ed_scroll_to_top__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_scroll_to_top__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _modules_ed_qty_discount_selector__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./modules/ed-qty-discount-selector */ "./src/js/modules/ed-qty-discount-selector.js");
/* harmony import */ var _modules_ed_quick_add__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./modules/ed-quick-add */ "./src/js/modules/ed-quick-add.js");
/* harmony import */ var _modules_ed_quick_add__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_quick_add__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _modules_ed_pre_purchase_upsell__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./modules/ed-pre-purchase-upsell */ "./src/js/modules/ed-pre-purchase-upsell.js");
/* harmony import */ var _modules_ed_pre_purchase_upsell__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_pre_purchase_upsell__WEBPACK_IMPORTED_MODULE_23__);
/*
DO NOT TOUCH THIS FILE OUTSIDE OF /src DIRECTORY
this file gets compiled ./assets/custom.js - make sure to import every module here.
*/

/* OVERRRIDES */
























})();

// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
/*!******************************!*\
  !*** ./src/scss/custom.scss ***!
  \******************************/
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin

})();

/******/ })()
;